/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	import * as global from "../../js/global";
	import * as helper from "../../js/helper";
	import full_loading from "../components/full-loading.vue";
	const __vue_script__ ={
		components: {
			full_loading:full_loading,
		},
		name:'add_mashro_widget',
		props: {
			mashro_json: {
				type: String,
			},
			mashro_name: {
				type: String,
			},
			owner_no: {
				type: String,
			},
			owner_email: {
				type: String,
			},
			regions_json: {
			},
		},
		data() {
			return {
				global,
				helper,
				frappe,
				regions:[],
				cities:[],
				ready:false,
				loading:false,
				agreement:null,
				policy_agreed:false,
				current_step: 0,
                mashro_guarantee_types: global.mashro_constants.mashro_guarantee_types,
                mashro_property_types: global.mashro_constants.mashro_property_types,
				agencies:[],
				members: [],
				images:[],
				main_image_index: 0,
				to_agency: null,
				edit_property: null,
				mashro: new global.Mashro(),
                edit_mashro: null,
				is_nafath_verified:false,
				ad_license_number: "",
				advertiser_id: null,
				borders:false,
				rer_borders:false,
				drawnItems: new L.FeatureGroup(),
				manual_file: null,
			}
		},
		async created(){
			if(this.mashro_json != undefined){
			    this.edit_mashro = JSON.parse(this.mashro_json);
				this.mashro.from_map(this.edit_mashro);				
			}
			if(this.regions_json != undefined){
			    this.regions = JSON.parse(this.regions_json);			
			}
		},
		async mounted(){
			global.emitter.emit("show-full-loading");
			if(!this.edit_mashro){
				if(frappe.user_roles.includes('Developer')){
					this.mashro.contact_no = '0' + frappe.session_user.substring(4);
					this.mashro.contact_email = this.owner_email;
					this.load_members();
				}else if(frappe.user_roles.includes('Member')){
					this.mashro.contact_no = '0' + frappe.session_user.substring(4);
					this.mashro.contact_email = frappe.session_user_email;
					this.load_agencies();
				}
			}
			
			this.setup_map();
			this.ready = true;
			global.emitter.emit("hide-full-loading");

			const inputs = document.getElementsByClassName("number-field");
			for (let i = 0; i < inputs.length; i++) {
				inputs[i].addEventListener("focus", function () {
					this.value = this.value.replace(/,/g, "");
				});

				inputs[i].addEventListener("blur", function () {
					let value = this.value.replace(/,/g, "");

					if (!isNaN(value) && value !== "") {
						this.value = Number(value).toLocaleString("en-US");
					}
				});
			}
		},
		methods: {
			load_members: async function(){
				global.emitter.emit("show-full-loading");
				this.is_loading = true;
				let params = {
					'mashro_managers':1
				};
				let url = "/api/method/maalek.api.get_agency_members";
				let res = await $.ajax({
					url: url,
					type: "GET",
					data: params
				});
				for (let index = 0; index < res.message.length; index++) {
					res.message[index]['creation'] = new Date(res.message[index]['creation']);
					this.members.push(res.message[index]);
				}
				this.is_loading = false;
				global.emitter.emit("hide-full-loading");
			},
			load_agencies: async function(){
				global.emitter.emit("show-full-loading");
				this.is_loading = true;
				let params = {
					'for_mashro':1
				};
				let url = "/api/method/maalek.api.get_registered_agencies";
				let res = await $.ajax({
					url: url,
					type: "GET",
					data: params
				});
				for (let index = 0; index < res.message.length; index++) {
					res.message[index]['creation'] = new Date(res.message[index]['creation']);
					this.agencies.push(res.message[index]);
				}
				if(this.agencies.length == 1){
					this.mashro.for_agency = this.agencies[0];
				}
				this.is_loading = false;
				global.emitter.emit("hide-full-loading");
			},
			region_changed: async function(){
				global.emitter.emit("show-full-loading");
				this.cities = [];
				this.mashro.city = null;
				this.is_loading = true;
				let params = {
					'region_id':this.mashro.region.region_id
				};
				let url = "/api/method/maalek.api.get_cities";
				let res = await $.ajax({
					url: url,
					type: "GET",
					data: params
				});
				for (let index = 0; index < res.message.length; index++) {
					this.cities.push(res.message[index]);
				}
				this.map.setView([this.mashro.region.lat, this.mashro.region.lng], 10);
				this.is_loading = false;
				global.emitter.emit("hide-full-loading");
			},
			city_changed: async function(){
				this.map.setView([this.mashro.city.lat, this.mashro.city.lng], 13);
			},
			confirm_save: async function () {
				// this.save_mashro();
				// return;
				if(!this.mashro.validate()){
					console.log(this.mashro.errors);
					bootbox.alert({
						title: helper.t("Error"),
						message:`<div class="alert alert-danger" role="alert">
									`+helper.t("Please fix the issues marked in Red Color")+`
								</div>`,
						size: 'large',
						buttons: {
							ok: {
								label: helper.t("Ok"),
								className: 'btn default-btn'
							}
						},
						// callback: (results) => results?this.save_mashro():console.log("cancel"),
					});
					return;
				}
				this.save_mashro();
			},
			save_mashro: async function(){
				try {
					global.emitter.emit("show-full-loading");
					
					const geojson = this.drawnItems.toGeoJSON();
					this.mashro.location = geojson;

					let params = this.mashro;
					let res = await $.ajax({
						headers: { 'X-Frappe-CSRF-Token': frappe.csrf_token },
						url: "/api/method/maalek.api.add_mashro",
						type: "POST",
						data: JSON.stringify(params)
					});
					this.mashro.name = res.message;
					global.emitter.emit("hide-full-loading");
					helper.showSuccess(this.edit_mashro?"Project Updated":"Project Saved",()=>{
						if(this.edit_mashro){
							location.reload();
						}else{
							location.replace("/account/my-projects");
						}
					});
				} catch (e) {
					console.log(e);
					global.emitter.emit("hide-full-loading");
					var exceptions = helper.showException(e);
				}
			},
			showModal: function(elementID){
				$(elementID).modal('show');
			},
			closeModal: function(elementID){
				$(elementID).modal('hide');
			},
			validate() {
				this.mashro.validate();
			},
			remove_image(image) {
				var image_index = this.mashro.images.indexOf(image);
				if (image_index >= 0) this.mashro.images.splice(image_index, 1);
				if (this.mashro.images.length <= this.mashro.main_image_index)
					this.mashro.main_image_index = this.mashro.images.length - 1;
				if (this.mashro.main_image_index < 0)
					this.mashro.main_image_index = 0;
				else this.validate();
			},
			pickFile() {
				let input = null;
				let files = null;
				
				input = this.$refs.file_input_parent;
				files = input.files;

				if (files && files[0]) {
					for (let index = 0; index < files.length; index++) {
						const single_file = files[index];
						let reader = new FileReader();
						reader.onload = (event) => {
							var image = new Image();
							image.onload = ()=>{
								var canvas=document.createElement("canvas");
								var context=canvas.getContext("2d");
								const size = 1024; // set your width
								var scaleFactor = size / image.width;
								canvas.width = image.width;
								canvas.height = image.height;
								if(image.width > image.height && image.width > size){
									scaleFactor = size / image.width;
									canvas.width = size;
									canvas.height = image.height * scaleFactor;
								}else if(image.width < image.height && image.height > size){
									scaleFactor = size / image.height;
									canvas.width = image.width * scaleFactor;
									canvas.height = size;
								}
								context.drawImage(image, 0, 0, canvas.width, canvas.height);
								this.mashro.images.push(
									new global.image_file({
									data: canvas.toDataURL("image/jpeg"),
									file: single_file.name,
									})
								);
							}
							image.src=event.target.result;
							console.log("added image");
							console.log(this.mashro.images);
							this.validate();
						};
						reader.readAsDataURL(single_file);
					}
					this.$forceUpdate();
				}
			},
			check_error(field, is_guarantee_type = false) {
				return this.mashro.errors.includes(field) ? "error" : "";
			},
			setup_map(initial_lat_lng = [24.69999996, 46.73333003]) {
				var initial_lat = initial_lat_lng[0]; 
				var initial_lng = initial_lat_lng[1];
				if(this.edit_mashro){
					var initial_lat = this.mashro.lat; 
                	var initial_lng = this.mashro.lng;
				}	
				let corner1 = L.latLng(31.896210012370656, 33.96066018865814);
				let corner2 = L.latLng(17.613607036429755, 55.8301100044458);
				var google_street_layer = L.tileLayer(
				"https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}",
				{
					maxZoom: 18,
					minZoom: 6,
					subdomains: ["mt0", "mt1", "mt2", "mt3"],
					attribution: '&copy; <a href="https://maalek.net">Maalek.Net</a>',
				}
				);
				var google_satellite_layer = L.tileLayer(
				"https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}",
				{
					maxZoom: 18,
					minZoom: 6,
					subdomains: ["mt0", "mt1", "mt2", "mt3"],
					attribution: '&copy; <a href="https://maalek.net">Maalek.Net</a>',
				}
				);
				var open_street = L.tileLayer(
				"https://tile.openstreetmap.org/{z}/{x}/{y}.png",
				{
					maxZoom: 18,
					minZoom: 6,
					attribution: '&copy; <a href="https://maalek.net">Maalek.Net</a>',
				}
				);
				this.mapsLayerGroup = new L.LayerGroup();
				this.markerLayerGroup = new L.LayerGroup();
				this.map = L.map("map", {
					center: [initial_lat, initial_lng],
					zoom: this.edit_mashro?16:10,
                    maxZoom: 18,
                    minZoom: 10,
					dragging: true,
					maxBounds: L.latLngBounds(corner1, corner2),
					layers: [
						this.mapsLayerGroup,
						this.markerLayerGroup,
					],
				}); //.setView([26.354351281510784, 43.95774780060444], 11);
				this.map.scrollWheelZoom.disable();
				this.mapsLayerGroup.addLayer(open_street);

				// this.drawnItems = new L.FeatureGroup();
				this.map.addLayer(this.drawnItems);
				
				L.drawLocal.draw.handlers.polygon.tooltip.start = helper.t('Click anywhere to start boundary');
				L.drawLocal.draw.handlers.polygon.tooltip.cont = helper.t('Click and continue drawing');
				L.drawLocal.draw.handlers.polygon.tooltip.end = helper.t('Click the first point to close the boundary');
				L.drawLocal.draw.toolbar.buttons.polygon = helper.t('Draw boundaries');
				L.drawLocal.draw.toolbar.actions = {title: helper.t('Cancel current boundary'), text: helper.t('Cancel')};
				L.drawLocal.draw.toolbar.finish = {title: helper.t('Finish boundary'), text: helper.t('Finish')};
				L.drawLocal.draw.toolbar.undo = {title: helper.t('Delete last point'), text: helper.t('Delete')};
				L.drawLocal.edit.handlers.remove.tooltip.text = helper.t('Click a mashro boundery to remove');
				L.drawLocal.edit.toolbar.buttons.edit = helper.t('Edit boundaries');
				L.drawLocal.edit.toolbar.buttons.editDisabled = helper.t('No boundary found on Map');
				L.drawLocal.edit.toolbar.buttons.removeDisabled = helper.t('No mashro added on Map');
				L.drawLocal.edit.toolbar.buttons.remove = helper.t('Remove boundaries');
				L.drawLocal.edit.toolbar.remove = helper.t('Remove boundaries');
				L.drawLocal.edit.toolbar.actions.save = {title: helper.t('Save'), text: helper.t('Save')};
				L.drawLocal.edit.toolbar.actions.cancel = {title: helper.t('Cancel'), text: helper.t('Cancel')};
				L.drawLocal.edit.toolbar.actions.clearAll = {title: helper.t('Clear'), text: helper.t('Clear All')};
				

				const drawControl = new L.Control.Draw({
					draw: {
						polygon: {
							allowIntersection: false,
							showArea: true,
							shapeOptions: {
								color: '#ff89ff'
							}
						},
						polyline: false,
						rectangle: false,
						circle: false,
						circlemarker: false,
						marker: false
					},
					edit: {
						featureGroup: this.drawnItems,
						remove: true
					}
				});

				this.map.addControl(drawControl);

				this.map.on(L.Draw.Event.CREATED, (event) => {
					const layer = event.layer;
					this.drawnItems.addLayer(layer);
					// const geojson = this.drawnItems.toGeoJSON();
					// this.mashro.location = geojson;
				});

				if(this.edit_mashro){
					var geo_json = JSON.parse(this.mashro.location);
					const geoJsonLayer = L.geoJSON(geo_json);
					geoJsonLayer.eachLayer((layer) => {
						this.drawnItems.addLayer(layer);
					});
				}				
			},
            set_guarantee_type(guarantee_type,if_zero = false){
                if(if_zero && this.mashro.guarantees[guarantee_type]!=0){
                    return
                }
                this.mashro.guarantees[guarantee_type] = this.mashro.guarantees[guarantee_type]==0?5:0;
            },
            set_property_type(property_type,if_zero = false){
                this.mashro.property_types[property_type] = !this.mashro.property_types[property_type];
            },
            member_changed(){
				this.mashro.contact_no = '0' + frappe.session_user.substring(4);
				this.mashro.contact_email = this.owner_email;
				if(this.mashro.to_member && this.mashro.to_member != ""){
					this.mashro.contact_no = '0' + this.mashro.to_member.member.substring(4);
					this.mashro.contact_email = this.mashro.to_member.email;
				}
				this.validate();
            },
			handleFileChange(event) {
				const file = event.target.files[0]
				this.mashro.manual_file = file ? file.name : ''
			},
			confirm_change_manual: async function (){
				bootbox.confirm({
					message: `<div class="alert alert-danger" role="alert">
							<b>`+helper.t("Do you want to re-upload project brochure?")+`</b><br>
							<small>`+helper.t("Caution: This will remove previous pdf file.")+`</small>
					</div>`,
					buttons: {
						confirm: {
							label: helper.t("Yes"),
							className: 'btn-success'
						},
						cancel: {
							label: helper.t("No"),
							className: 'btn-danger'
						}
					},
					backdrop: true,
					callback: (results) => results?this.$refs.pdfFileInput.click():console.log("cancel"),
				});
			},
			onPickFile () {
				if(this.edit_mashro && this.mashro.manual_doc){
					this.confirm_change_manual();
				}else{
					this.$refs.pdfFileInput.click()
				}
			},
			pdfPickFile () {
                let input = null;
                let files = null;
                input = this.$refs.pdfFileInput;
                files = input.files;
                if (files && files[0]) {
					const fileReader = new FileReader()
					fileReader.readAsDataURL(files[0])
					let reader = new FileReader;
					reader.onload = e => {
						this.mashro.manual_file = new global.pdf_file({
							data: e.target.result,
							file: files[0].name,
							type: files[0].type,
						});
					}
					reader.readAsDataURL(files[0]);
					this.$forceUpdate();
                }
            },
			set_communication (type) {
				if(type == 'phone'){
					if(this.mashro.phone && (this.mashro.email || this.mashro.whatsapp)){
						this.mashro.phone = false;
					}else if(this.mashro.phone){
						helper.showException("Atleast one communication method is needed");
					}else{
						this.mashro.phone = true;
					}
				}else if(type == 'whatsapp'){
					if(this.mashro.whatsapp && (this.mashro.phone || this.mashro.email)){
						this.mashro.whatsapp = false;
					}else if(this.mashro.whatsapp){
						helper.showException("Atleast one communication method is needed");
					}else{
						this.mashro.whatsapp = true;
					}
				}else if(type == 'email'){
					if(this.mashro.email && (this.mashro.phone || this.mashro.whatsapp)){
						this.mashro.email = false;
					}else if(this.mashro.email){
						helper.showException("Atleast one communication method is needed");
					}else{
						this.mashro.email = true;
					}
				}
			}
		},
		computed:{
		}
	}

/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "add_property_widget pb-5" },
    [
      _c("full_loading"),
      _vm._v(" "),
      _c("div", { staticClass: "section-card" }, [
        _vm._m(0),
        _vm._v(" "),
        !_vm.edit_mashro
          ? _c("div", { staticClass: "row g-3" }, [
              _c("div", { staticClass: "col-md-3" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.mashro.ready_made,
                          expression: "mashro.ready_made"
                        }
                      ],
                      staticClass: "form-select form-control border-radius",
                      class: _vm.check_error("ready_made"),
                      attrs: { "aria-label": "Default select example" },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.mashro,
                            "ready_made",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        }
                      }
                    },
                    [
                      _c(
                        "option",
                        { attrs: { disabled: "" }, domProps: { value: null } },
                        [_vm._v(_vm._s(_vm.helper.t("Select Project Type")))]
                      ),
                      _vm._v(" "),
                      _c("option", { domProps: { value: 0 } }, [
                        _vm._v(_vm._s(_vm.helper.t("On the map")))
                      ]),
                      _vm._v(" "),
                      _c("option", { domProps: { value: 1 } }, [
                        _vm._v(_vm._s(_vm.helper.t("Ready-made units")))
                      ])
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-3" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.mashro.region,
                          expression: "mashro.region"
                        }
                      ],
                      staticClass: "form-select form-control border-radius",
                      class: _vm.check_error("region"),
                      attrs: { "aria-label": "Default select example" },
                      on: {
                        change: [
                          function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.mashro,
                              "region",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                          _vm.region_changed
                        ]
                      }
                    },
                    [
                      _c(
                        "option",
                        { attrs: { disabled: "" }, domProps: { value: null } },
                        [_vm._v(_vm._s(_vm.helper.t("Select Region")))]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.regions, function(region) {
                        return _c("option", { domProps: { value: region } }, [
                          _vm._v(_vm._s(region.name_ar))
                        ])
                      })
                    ],
                    2
                  )
                ])
              ]),
              _vm._v(" "),
              _vm.mashro.region
                ? _c("div", { staticClass: "col-md-3" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.mashro.city,
                              expression: "mashro.city"
                            }
                          ],
                          staticClass: "form-select form-control border-radius",
                          class: _vm.check_error("city"),
                          attrs: { "aria-label": "Default select example" },
                          on: {
                            change: [
                              function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.mashro,
                                  "city",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                              _vm.city_changed
                            ]
                          }
                        },
                        [
                          _c(
                            "option",
                            {
                              attrs: { disabled: "" },
                              domProps: { value: null }
                            },
                            [_vm._v(_vm._s(_vm.helper.t("Select City")))]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.cities, function(city) {
                            return _c("option", { domProps: { value: city } }, [
                              _vm._v(_vm._s(city.name_ar))
                            ])
                          })
                        ],
                        2
                      )
                    ])
                  ])
                : _vm._e()
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "row g-3" }, [
          _c("div", { staticClass: "col-md-3" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", [
                _vm._v(" " + _vm._s(_vm.helper.t("Project Name")) + " ")
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.mashro.title,
                    expression: "mashro.title"
                  }
                ],
                staticClass: "form-control border-radius",
                class: _vm.check_error("title"),
                attrs: {
                  placeholder: _vm.helper.t("Enter project name"),
                  type: "text"
                },
                domProps: { value: _vm.mashro.title },
                on: {
                  change: _vm.validate,
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.mashro, "title", $event.target.value)
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-3" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", [
                _vm._v(" " + _vm._s(_vm.helper.t("Address")) + " ")
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.mashro.address,
                    expression: "mashro.address"
                  }
                ],
                staticClass: "form-control border-radius",
                class: _vm.check_error("address"),
                attrs: {
                  placeholder: _vm.helper.t("Enter project address"),
                  type: "text"
                },
                domProps: { value: _vm.mashro.address },
                on: {
                  change: _vm.validate,
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.mashro, "address", $event.target.value)
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-3" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", [
                _vm._v(" " + _vm._s(_vm.helper.t("Total Units")) + " ")
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.mashro.units,
                    expression: "mashro.units"
                  }
                ],
                staticClass: "form-control border-radius",
                class: _vm.check_error("units"),
                attrs: {
                  placeholder: _vm.helper.t("Enter No. of Units"),
                  type: "number",
                  step: "1",
                  min: "0"
                },
                domProps: { value: _vm.mashro.units },
                on: {
                  change: function($event) {
                    return _vm.validate()
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.mashro, "units", $event.target.value)
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-3" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", [
                _vm._v(" " + _vm._s(_vm.helper.t("Project Brochure")) + " ")
              ]),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass:
                    "form-control border-radius d-flex justify-content-between align-items-center",
                  staticStyle: { cursor: "pointer" },
                  on: { click: _vm.onPickFile }
                },
                [
                  [
                    !_vm.mashro.manual_file
                      ? _c(
                          "small",
                          { staticClass: "text-placeholder-color fw-normal" },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t" +
                                _vm._s(_vm.helper.t("No file selected")) +
                                "\n\t\t\t\t\t\t\t"
                            )
                          ]
                        )
                      : _c("small", { staticClass: "text-placeholder-color" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t" +
                              _vm._s(
                                _vm.mashro.manual_file.file.substring(0, 12) +
                                  "..." +
                                  _vm.mashro.manual_file.file.substring(
                                    _vm.mashro.manual_file.file.length - 4
                                  )
                              ) +
                              "\n\t\t\t\t\t\t\t"
                          )
                        ]),
                    _vm._v(" "),
                    _c("small", { staticClass: "btn btn-primary btn-sm" }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t\t\t" +
                          _vm._s(_vm.helper.t("Select PDF File")) +
                          "\n\t\t\t\t\t\t\t"
                      )
                    ])
                  ]
                ],
                2
              ),
              _vm._v(" "),
              _c("input", {
                ref: "pdfFileInput",
                staticClass: "d-none",
                class: _vm.check_error("manual_file"),
                attrs: { type: "file", accept: "application/pdf" },
                on: { input: _vm.pdfPickFile }
              }),
              _vm._v(" "),
              _vm.edit_mashro && _vm.mashro.manual_doc
                ? _c(
                    "a",
                    {
                      attrs: { href: _vm.mashro.manual_doc, target: "_blank" }
                    },
                    [
                      _c("small", {}, [
                        _c("img", {
                          staticStyle: { height: "30px" },
                          attrs: { src: "/assets/maalek/images/pdf.svg" }
                        }),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t" +
                            _vm._s(_vm.helper.t("Project Brochure")) +
                            "\n\t\t\t\t\t\t"
                        )
                      ])
                    ]
                  )
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-3" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", [
                _vm._v(" " + _vm._s(_vm.helper.t("Min Price")) + " ")
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.mashro.price_min,
                    expression: "mashro.price_min"
                  }
                ],
                staticClass: "form-control border-radius",
                class: _vm.check_error("price_min"),
                attrs: {
                  placeholder: _vm.helper.t("Enter Min Price"),
                  type: "number",
                  step: "1",
                  min: "0"
                },
                domProps: { value: _vm.mashro.price_min },
                on: {
                  change: function($event) {
                    return _vm.validate()
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.mashro, "price_min", $event.target.value)
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-3" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", [
                _vm._v(" " + _vm._s(_vm.helper.t("Max Price")) + " ")
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.mashro.price_max,
                    expression: "mashro.price_max"
                  }
                ],
                staticClass: "form-control border-radius",
                class: _vm.check_error("price_max"),
                attrs: {
                  placeholder: _vm.helper.t("Enter Max Price"),
                  type: "number",
                  step: "1",
                  min: "0"
                },
                domProps: { value: _vm.mashro.price_max },
                on: {
                  change: function($event) {
                    return _vm.validate()
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.mashro, "price_max", $event.target.value)
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-3" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", [
                _vm._v(" " + _vm._s(_vm.helper.t("Min Area")) + " ")
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.mashro.area_min,
                    expression: "mashro.area_min"
                  }
                ],
                staticClass: "form-control border-radius",
                class: _vm.check_error("area_min"),
                attrs: {
                  placeholder: _vm.helper.t("Enter Min Area"),
                  type: "number",
                  step: "1",
                  min: "0"
                },
                domProps: { value: _vm.mashro.area_min },
                on: {
                  change: function($event) {
                    return _vm.validate()
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.mashro, "area_min", $event.target.value)
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-3" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", [
                _vm._v(" " + _vm._s(_vm.helper.t("Max Area")) + " ")
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.mashro.area_max,
                    expression: "mashro.area_max"
                  }
                ],
                staticClass: "form-control border-radius",
                class: _vm.check_error("area_max"),
                attrs: {
                  placeholder: _vm.helper.t("Enter Max Area"),
                  type: "number",
                  step: "1",
                  min: "0"
                },
                domProps: { value: _vm.mashro.area_max },
                on: {
                  change: function($event) {
                    return _vm.validate()
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.mashro, "area_max", $event.target.value)
                  }
                }
              })
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "section-card" }, [
        _c("div", { staticClass: "d-flex align-items-center gap-2 mb-4" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("div", [
            _c("h4", { staticClass: "mb-1" }, [
              _vm._v(_vm._s(_vm.helper.t("Contact Info")))
            ]),
            _vm._v(" "),
            _c("small", { staticClass: "text-muted" }, [
              _vm._v(
                _vm._s(
                  _vm.helper.t("Mention contact information for your project")
                )
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row g-3" }, [
          _vm.members.length > 0
            ? _c("div", { staticClass: "col-md-4" }, [
                !_vm.edit_mashro
                  ? _c("div", { staticClass: "form-group" }, [
                      _c("label", [
                        _vm._v(_vm._s(_vm.helper.t("Project Manager")))
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.mashro.to_member,
                              expression: "mashro.to_member"
                            }
                          ],
                          staticClass: "form-select form-control border-radius",
                          class: _vm.mashro.to_member ? "" : "",
                          attrs: { "aria-label": "Default select example" },
                          on: {
                            change: [
                              function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.mashro,
                                  "to_member",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                              _vm.member_changed
                            ]
                          }
                        },
                        [
                          _c("option", { domProps: { value: null } }, [
                            _vm._v(
                              _vm._s(
                                _vm.helper.t(
                                  "Managed by company's main account"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.members, function(member) {
                            return _c(
                              "option",
                              { domProps: { value: member } },
                              [
                                _vm._v(
                                  _vm._s(member["full_name"]) +
                                    " - (0" +
                                    _vm._s(member["member"].substring(4)) +
                                    ")"
                                )
                              ]
                            )
                          })
                        ],
                        2
                      )
                    ])
                  : _c("div", { staticClass: "form-group" }, [
                      _c("label", [
                        _vm._v(_vm._s(_vm.helper.t("Project Manager")))
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.mashro.manager_user_fullname,
                            expression: "mashro.manager_user_fullname"
                          }
                        ],
                        staticClass: "form-control border-radius",
                        attrs: { type: "text", disabled: "" },
                        domProps: { value: _vm.mashro.manager_user_fullname },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.mashro,
                              "manager_user_fullname",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
              ])
            : _vm.agencies.length > 0 && !_vm.edit_mashro
            ? _c("div", { staticClass: "col-md-4" }, [
                _vm.agencies.length > 1
                  ? _c("div", { staticClass: "form-group" }, [
                      _c("label", [
                        _vm._v(_vm._s(_vm.helper.t("Select Developer")))
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.mashro.for_agency,
                              expression: "mashro.for_agency"
                            }
                          ],
                          staticClass: "form-select form-control border-radius",
                          attrs: { "aria-label": "Default select example" },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.mashro,
                                "for_agency",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { value: "" } }, [
                            _vm._v(_vm._s(_vm.helper.t("Select Developer")))
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.agencies, function(agency) {
                            return _c(
                              "option",
                              { domProps: { value: agency } },
                              [
                                _vm._v(
                                  _vm._s(agency.full_name) +
                                    " - (0" +
                                    _vm._s(agency.agency.substring(4)) +
                                    ")"
                                )
                              ]
                            )
                          })
                        ],
                        2
                      )
                    ])
                  : _vm.agencies.length > 0
                  ? _c("div", { staticClass: "form-group" }, [
                      _c("label", [_vm._v(_vm._s(_vm.helper.t("Developer")))]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.mashro.for_agency["full_name"],
                            expression: "mashro.for_agency['full_name']"
                          }
                        ],
                        staticClass: "form-control border-radius",
                        attrs: { type: "text", disabled: "" },
                        domProps: { value: _vm.mashro.for_agency["full_name"] },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.mashro.for_agency,
                              "full_name",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  : _vm._e()
              ])
            : _vm.edit_mashro
            ? _c("div", { staticClass: "col-md-4" }, [
                _vm.mashro.owned
                  ? _c("div", { staticClass: "form-group" }, [
                      _c("label", [
                        _vm._v(_vm._s(_vm.helper.t("Project Manager")))
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.mashro.manager_user_fullname,
                            expression: "mashro.manager_user_fullname"
                          }
                        ],
                        staticClass: "form-control border-radius",
                        attrs: { type: "text", disabled: "" },
                        domProps: { value: _vm.mashro.manager_user_fullname },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.mashro,
                              "manager_user_fullname",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  : _c("div", { staticClass: "form-group" }, [
                      _c("label", [_vm._v(_vm._s(_vm.helper.t("Developer")))]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.mashro.owner_fullname,
                            expression: "mashro.owner_fullname"
                          }
                        ],
                        staticClass: "form-control border-radius",
                        attrs: { type: "text", disabled: "" },
                        domProps: { value: _vm.mashro.owner_fullname },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.mashro,
                              "owner_fullname",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", [
                _vm._v(" " + _vm._s(_vm.helper.t("Contact No")) + " ")
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.mashro.contact_no,
                    expression: "mashro.contact_no"
                  }
                ],
                staticClass: "form-control border-radius",
                class: _vm.check_error("contact_no"),
                attrs: { type: "text" },
                domProps: { value: _vm.mashro.contact_no },
                on: {
                  change: _vm.validate,
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.mashro, "contact_no", $event.target.value)
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", [
                _vm._v(" " + _vm._s(_vm.helper.t("Contact Email")) + " ")
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.mashro.contact_email,
                    expression: "mashro.contact_email"
                  }
                ],
                staticClass: "form-control border-radius",
                class: _vm.check_error("contact_email"),
                attrs: { type: "text" },
                domProps: { value: _vm.mashro.contact_email },
                on: {
                  change: _vm.validate,
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.mashro, "contact_email", $event.target.value)
                  }
                }
              })
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex align-items-center gap-2 mb-4" }, [
          _c("div", [
            _c("small", { staticClass: "text-muted" }, [
              _vm._v(
                _vm._s(_vm.helper.t("Select Prefered Coomunication Medium"))
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row g-3" }, [
          _c("div", { staticClass: "col-2" }, [
            _c(
              "div",
              {
                staticClass: "facility_type",
                class: _vm.mashro.phone ? "selected" : "",
                on: {
                  click: function($event) {
                    return _vm.set_communication("phone")
                  }
                }
              },
              [
                _c("i", { staticClass: "ri-phone-fill" }),
                _vm._v(" "),
                _c("div", [_vm._v(_vm._s(_vm.helper.t("Phone")))])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-2" }, [
            _c(
              "div",
              {
                staticClass: "facility_type",
                class: _vm.mashro.whatsapp ? "selected" : "",
                on: {
                  click: function($event) {
                    return _vm.set_communication("whatsapp")
                  }
                }
              },
              [
                _c("i", { staticClass: "ri-whatsapp-fill" }),
                _vm._v(" "),
                _c("div", [_vm._v(_vm._s(_vm.helper.t("Whatsapp")))])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-2" }, [
            _c(
              "div",
              {
                staticClass: "facility_type",
                class: _vm.mashro.email ? "selected" : "",
                on: {
                  click: function($event) {
                    return _vm.set_communication("email")
                  }
                }
              },
              [
                _c("i", { staticClass: "ri-mail-fill" }),
                _vm._v(" "),
                _c("div", [_vm._v(_vm._s(_vm.helper.t("Email")))])
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "section-card features-content" }, [
        _c("div", { staticClass: "d-flex align-items-center gap-2 mb-4" }, [
          _vm._m(2),
          _vm._v(" "),
          _c("div", [
            _c("h4", { staticClass: "mb-1" }, [
              _vm._v(_vm._s(_vm.helper.t("Property Types")))
            ]),
            _vm._v(" "),
            _c("small", { staticClass: "text-muted" }, [
              _vm._v("اختر الوحدات العقارية المتوفرة في المشروع")
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "row g-3" },
          _vm._l(_vm.mashro_property_types, function(property_type) {
            return _c("div", { staticClass: "col-2" }, [
              _c(
                "div",
                {
                  staticClass: "property_type",
                  class: _vm.mashro.property_types[property_type]
                    ? "selected"
                    : "",
                  on: {
                    click: function($event) {
                      return _vm.set_property_type(property_type, true)
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: {
                      src: _vm.global.global_params.legend_icons[property_type]
                    }
                  }),
                  _vm._v(" "),
                  _c("div", [_vm._v(_vm._s(_vm.helper.t(property_type + "s")))])
                ]
              )
            ])
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "section-card features-content" }, [
        _c("div", { staticClass: "d-flex align-items-center gap-2 mb-4" }, [
          _vm._m(3),
          _vm._v(" "),
          _c("div", [
            _c("h4", { staticClass: "mb-1" }, [
              _vm._v(_vm._s(_vm.helper.t("Guarantees")))
            ]),
            _vm._v(" "),
            _c("small", { staticClass: "text-muted" }, [
              _vm._v("أضف مدة الضمان لكل عنصر")
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "row g-3" },
          _vm._l(_vm.mashro_guarantee_types, function(guarantee_type) {
            return _c("div", { staticClass: "col-lg-3 col-md-4" }, [
              _c(
                "div",
                {
                  class:
                    _vm.mashro.guarantees[guarantee_type] > 0
                      ? "text-success"
                      : ""
                },
                [
                  _c("div", { staticClass: "form-check form-switch" }, [
                    _c("input", {
                      staticClass: "form-check-input",
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: _vm.mashro.guarantees[guarantee_type] > 0
                      },
                      on: {
                        change: function($event) {
                          return _vm.set_guarantee_type(guarantee_type)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "form-check-label",
                        attrs: { for: "flexSwitchCheckDefault" }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.helper.t("g_" + guarantee_type.toLowerCase())
                          )
                        )
                      ]
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "input-group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.mashro.guarantees[guarantee_type],
                      expression: "mashro.guarantees[guarantee_type]"
                    }
                  ],
                  staticClass: "form-control border-radius",
                  class:
                    _vm.mashro.guarantees[guarantee_type] == 0
                      ? "bg-light text-muted"
                      : "border-1 border-success",
                  attrs: {
                    name: guarantee_type,
                    readonly: _vm.mashro.guarantees[guarantee_type] == 0,
                    type: "number",
                    step: "1",
                    min: "1"
                  },
                  domProps: { value: _vm.mashro.guarantees[guarantee_type] },
                  on: {
                    click: function($event) {
                      _vm.mashro.guarantees[guarantee_type] == 0
                        ? _vm.set_guarantee_type(guarantee_type, true)
                        : null
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.mashro.guarantees,
                        guarantee_type,
                        $event.target.value
                      )
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "input-group-text",
                    attrs: { id: "basic-addon2" },
                    on: {
                      click: function($event) {
                        _vm.mashro.guarantees[guarantee_type] == 0
                          ? _vm.set_guarantee_type(guarantee_type, true)
                          : null
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t" +
                        _vm._s(_vm.helper.t("Year")) +
                        "\n\t\t\t\t\t"
                    )
                  ]
                )
              ])
            ])
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "section-card" }, [
        _c("div", { staticClass: "features-content" }, [
          _c("div", { staticClass: "d-flex align-items-center gap-2 mb-4" }, [
            _vm._m(4),
            _vm._v(" "),
            _c("div", [
              _c("h4", { staticClass: "mb-1" }, [
                _vm._v(_vm._s(_vm.helper.t("Facilities")))
              ]),
              _vm._v(" "),
              _c("small", { staticClass: "text-muted" }, [
                _vm._v("اختر المرافق المتوفرة في المشروع")
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row g-3" }, [
            _c("div", { staticClass: "col-2" }, [
              _c(
                "div",
                {
                  staticClass: "facility_type",
                  class: _vm.mashro.masjid ? "selected" : "",
                  on: {
                    click: function($event) {
                      _vm.mashro.masjid = !_vm.mashro.masjid
                    }
                  }
                },
                [
                  _c("i", { staticClass: "fa-solid fa-mosque fa-lg" }),
                  _vm._v(" "),
                  _c("div", [_vm._v(_vm._s(_vm.helper.t("Masjid")))])
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-2" }, [
              _c(
                "div",
                {
                  staticClass: "facility_type",
                  class: _vm.mashro.health ? "selected" : "",
                  on: {
                    click: function($event) {
                      _vm.mashro.health = !_vm.mashro.health
                    }
                  }
                },
                [
                  _c("i", { staticClass: "fa-solid fa-heart-pulse fa-lg" }),
                  _vm._v(" "),
                  _c("div", [_vm._v(_vm._s(_vm.helper.t("Health")))])
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-2" }, [
              _c(
                "div",
                {
                  staticClass: "facility_type",
                  class: _vm.mashro.shopping ? "selected" : "",
                  on: {
                    click: function($event) {
                      _vm.mashro.shopping = !_vm.mashro.shopping
                    }
                  }
                },
                [
                  _c("i", { staticClass: "fa-solid fa-cart-shopping fa-lg" }),
                  _vm._v(" "),
                  _c("div", [_vm._v(_vm._s(_vm.helper.t("Shopping")))])
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-2" }, [
              _c(
                "div",
                {
                  staticClass: "facility_type",
                  class: _vm.mashro.park ? "selected" : "",
                  on: {
                    click: function($event) {
                      _vm.mashro.park = !_vm.mashro.park
                    }
                  }
                },
                [
                  _c("i", { staticClass: "fa-solid fa-cart-shopping fa-lg" }),
                  _vm._v(" "),
                  _c("div", [_vm._v(_vm._s(_vm.helper.t("Park")))])
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-2" }, [
              _c(
                "div",
                {
                  staticClass: "facility_type",
                  class: _vm.mashro.school_male ? "selected" : "",
                  on: {
                    click: function($event) {
                      _vm.mashro.school_male = !_vm.mashro.school_male
                    }
                  }
                },
                [
                  _c("i", { staticClass: "fa-solid fa-graduation-cap fa-lg" }),
                  _vm._v(" "),
                  _c("div", [_vm._v(_vm._s(_vm.helper.t("Male School")))])
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-2" }, [
              _c(
                "div",
                {
                  staticClass: "facility_type",
                  class: _vm.mashro.school_female ? "selected" : "",
                  on: {
                    click: function($event) {
                      _vm.mashro.school_female = !_vm.mashro.school_female
                    }
                  }
                },
                [
                  _c("i", { staticClass: "fa-solid fa-graduation-cap fa-lg" }),
                  _vm._v(" "),
                  _c("div", [_vm._v(_vm._s(_vm.helper.t("Female School")))])
                ]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "section-card" }, [
        _c("div", { staticClass: "features-content" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-lg-12" }, [
              _c("div", { staticClass: "form-group" }, [
                _c(
                  "div",
                  { staticClass: "d-flex align-items-center gap-2 mb-4" },
                  [
                    _vm._m(5),
                    _vm._v(" "),
                    _c("div", [
                      _c("h4", { staticClass: "mb-1" }, [
                        _vm._v(_vm._s(_vm.helper.t("Video")))
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-6" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.mashro.video,
                          expression: "mashro.video"
                        }
                      ],
                      staticClass: "form-control border-radius",
                      class: _vm.check_error("video"),
                      attrs: {
                        placeholder: "أضف  فيديو المشروع (رابط يوتيوب)",
                        type: "text"
                      },
                      domProps: { value: _vm.mashro.video },
                      on: {
                        change: _vm.validate,
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.mashro, "video", $event.target.value)
                        }
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "d-flex align-items-center gap-2 mb-4" },
                  [
                    _vm._m(6),
                    _vm._v(" "),
                    _c("div", [
                      _c("h4", { staticClass: "mb-1" }, [
                        _vm._v(_vm._s(_vm.helper.t("Images")))
                      ]),
                      _vm._v(" "),
                      _c("small", { staticClass: "text-muted" }, [
                        _vm._v("أضف صور المشروع")
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "row images-container",
                    class: _vm.check_error("main_image_index")
                  },
                  [
                    _vm._l(_vm.mashro.images, function(image, image_index) {
                      return _c(
                        "div",
                        {
                          staticClass: "col-sm-6 col-md-3 image-input-container"
                        },
                        [
                          _c("div", {
                            staticClass: "imagePreviewWrapper",
                            style: {
                              "background-image":
                                "url(" +
                                (image.link ? image.link : image.data) +
                                ")"
                            },
                            on: {
                              click: function($event) {
                                _vm.mashro.main_image_index = image_index
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("i", {
                            staticClass:
                              "fa-solid fa-trash fa-2x delete text-danger",
                            on: {
                              click: function($event) {
                                return _vm.remove_image(image)
                              }
                            }
                          }),
                          _vm._v(" "),
                          image_index == _vm.mashro.main_image_index
                            ? _c("i", {
                                staticClass:
                                  "fa-solid fa-square-check fa-2x main text-primary"
                              })
                            : _vm._e()
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-lg-3 image-input-container" },
                      [
                        _c("label", {
                          staticClass: "imageEmptyWrapper",
                          attrs: { for: "file_parent" }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          ref: "file_input_parent",
                          staticClass: "input-file",
                          attrs: {
                            id: "file_parent",
                            type: "file",
                            accept: "image/png, image/gif, image/jpeg",
                            multiple: ""
                          },
                          on: { input: _vm.pickFile }
                        })
                      ]
                    )
                  ],
                  2
                )
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "section-card" }, [
        _c("div", { staticClass: "features-content" }, [
          _c(
            "div",
            { staticClass: "row", class: _vm.check_error("location") },
            [
              _c(
                "div",
                { staticClass: "d-flex align-items-center gap-2 mb-4" },
                [
                  _vm._m(7),
                  _vm._v(" "),
                  _c("div", [
                    _c("h4", { staticClass: "mb-1" }, [
                      _vm._v(_vm._s(_vm.helper.t("Project Boundries")))
                    ]),
                    _vm._v(" "),
                    _c("small", { staticClass: "text-muted" }, [
                      _vm._v("حدد موقع المشروع على الخريطة")
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _vm._m(8)
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col show-hand text-center" }, [
              _c(
                "a",
                {
                  staticClass: "btn default-btn mt-4 show-hand",
                  on: {
                    click: function($event) {
                      return _vm.confirm_save()
                    }
                  }
                },
                [
                  _c("p", [
                    _vm._v(
                      _vm._s(
                        _vm.helper.t(
                          this.edit_mashro
                            ? "Update Project"
                            : "Save & Publish Project"
                        )
                      )
                    )
                  ])
                ]
              )
            ])
          ])
        ])
      ])
    ],
    1
  )
}
var __vue_staticRenderFns__ = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex align-items-center gap-2 mb-4" }, [
      _c("div", { staticClass: "icon-badge" }, [
        _c("i", { staticClass: "ri-information-line" })
      ]),
      _vm._v(" "),
      _c("div", [
        _c("h4", { staticClass: "mb-1" }, [_vm._v("المعلومات الأساسية")]),
        _vm._v(" "),
        _c("small", { staticClass: "text-muted" }, [
          _vm._v("أضف البيانات الأساسية لمشروعك")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon-badge" }, [
      _c("i", { staticClass: "ri-contacts-book-line" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon-badge" }, [
      _c("i", { staticClass: "ri-information-line" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon-badge" }, [
      _c("i", { staticClass: "ri-shield-check-line" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon-badge" }, [
      _c("i", { staticClass: "ri-community-line" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon-badge" }, [
      _c("i", { staticClass: "ri-youtube-fill" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon-badge" }, [
      _c("i", { staticClass: "fa-regular fa-images" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon-badge" }, [
      _c("i", { staticClass: "ri-map-pin-line" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12", attrs: { dir: "ltr" } }, [
      _c("div", { staticStyle: { height: "500px" }, attrs: { id: "map" } })
    ])
  }
]
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-17b562fe_0", { source: "\n.image-input-container {\r\n  display: block;\r\n  position: relative;\n}\n.image-input-container .delete {\r\n  position: absolute;\r\n  top: 5%;\r\n  right: 10%;\r\n  text-shadow: 1px 1px 2px #000;\n}\n.image-input-container .main {\r\n  position: absolute;\r\n  top: 5%;\r\n  left: 10%;\r\n  text-shadow: 1px 1px 2px #000;\n}\n.image-input-container .input-file {\r\n  height: 0.1px;\r\n  width: 0.1px;\r\n  display: none;\n}\n.imagePreviewWrapper {\r\n  width: 100%;\r\n  padding-top: 100%;\r\n  display: block;\r\n  cursor: pointer;\r\n  margin: 0 auto 30px;\r\n  background-color: aliceblue;\r\n  background-repeat: no-repeat;\r\n  background-size: cover;\r\n  background-position: center;\n}\n.imageEmptyWrapper {\r\n  width: 100%;\r\n  padding-top: 100%;\r\n  display: block;\r\n  cursor: pointer;\r\n  margin: 0 auto 30px;\r\n  background-color: aliceblue;\r\n  background-image: url(\"/assets/maalek/images/circle-plus-solid.svg\");\r\n  background-repeat: no-repeat;\r\n  background-size: 20%;\r\n  background-position: center;\n}\n.images-container {\r\n  padding: 5px;\n}\n.images-container.error {\r\n  border: SOLID 1px red;\r\n  background-color: rgba(255, 0, 0, 0.1215686275) !important;\n}\n#app {\r\n\ttext-align: center;\r\n\tcolor: #2c3e50;\r\n\tmargin-top: 60px;\n}\n.single-pricing .default-btn{\r\n\tmargin-bottom: unset;\n}\n.features-content ul *{\r\n\tcursor: pointer;\n}\n.pricing-switch{\r\n\tmargin-bottom: 0;\r\n\tmargin-top: 10px;\r\n\ttext-align: start;\n}\n.pricing-switch .toggler{\r\n\tmargin-top: 10px;\n}\n.accordion-item .accordion-body ul li::before {\r\n\tdisplay: none;\n}\n.features-content *{\r\n\tuser-select: none;\n}\n.floor-table{\r\n\tborder-right: SOLID 2px #014116;\n}\n.floor-table h3{\r\n\tfont-size: 1.2rem;\n}\n.floor-table .actions *{\r\n\tcolor: #014116;\n}\n.floor-row:hover{\r\n\tbackground-color: aliceblue;\n}\n.show-on-hover, .show-on-hover-child{\r\n\tcursor: pointer;\n}\n.floor-row .show-on-hover{\r\n\tdisplay: none;\n}\n.floor-row:hover .show-on-hover{\r\n\tdisplay: block;\n}\n.tags{\r\n\tcursor: pointer;\n}\n.tags:hover{\r\n\tbackground-color: #014116;\n}\n.tags:hover *{\r\n\tcolor: #fff;\n}\n.tags span{\r\n\tborder: SOLID 2px;\r\n\tpadding: 5px;\n}\n.tags ul{\r\n\tpadding: 5px !important;\n}\n.tags ul li{\r\n\tpadding-left: 5px !important;\r\n\tdisplay: inline-block !important;\n}\n.modal-dialog{\r\n\t/* max-width: 70% !important; */\n}\n.add_property_widget{\r\n\tposition: relative;\n}\n.modal-content {\r\n  overflow: auto !important;\n}\n.features-content ul {\r\n\tpadding-left: 0;\r\n\tmargin-bottom: 0;\r\n\tlist-style-type: none;\r\n\tmargin-bottom: 10px;\n}\n.form-check-input:checked {\r\n\tbackground-color: green;\r\n\tborder-color: darkgreen;\n}\n.form-check-input:focus {\r\n\t--bs-form-check-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23198754'/%3e%3c/svg%3e\");\r\n  \tbox-shadow: 0 0 0 0.15rem lightgreen;\n}\n.property_type{\r\n\tborder: 1px solid #e5e7eb;\r\n\tborder-radius: 12px;\r\n\tpadding: 18px;\r\n\ttext-align: center;\r\n\ttransition: 0.2s;\r\n\tcursor: pointer;\r\n\theight: 100%;\n}\n.property_type:hover {\r\n\tborder-color: #198754;\r\n\tbackground: #f8fffb;\r\n\tcolor: green;\n}\n.property_type.selected{\r\n\tbackground-color: green;\r\n\tcolor: white;\n}\n.property_type.selected:hover {\r\n\tborder-color: #198754;\n}\n.property_type img {\r\n\twidth: 40px;\n}\n.facility_type{\r\n\tborder: 1px solid #e5e7eb;\r\n\tborder-radius: 12px;\r\n\tpadding: 18px;\r\n\ttext-align: center;\r\n\ttransition: 0.2s;\r\n\tcursor: pointer;\r\n\theight: 100%;\n}\n.facility_type i{\r\n\tfont-size: 1.5rem;\n}\n.facility_type.selected{\r\n\tbackground-color: green;\r\n\tcolor: white;\n}\n.facility_type.selected i{\r\n\tcolor: white;\n}\n.facility_type:hover{\r\n\tborder-color: #198754;\r\n\tbackground: #f8fffb;\r\n\tcolor: green;\n}\n.facility_type:hover i {\r\n\tborder-color: #198754;\r\n\tbackground: #f8fffb;\r\n\tcolor: green;\n}\r\n", map: {"version":3,"sources":["../maalek/maalek/public/vue/widgets/add-mashro-widget.vue"],"names":[],"mappings":";AAmhCA;EACA,cAAA;EACA,kBAAA;AACA;AACA;EACA,kBAAA;EACA,OAAA;EACA,UAAA;EACA,6BAAA;AACA;AACA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,6BAAA;AACA;AACA;EACA,aAAA;EACA,YAAA;EACA,aAAA;AACA;AACA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,2BAAA;EACA,4BAAA;EACA,sBAAA;EACA,2BAAA;AACA;AACA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,2BAAA;EACA,oEAAA;EACA,4BAAA;EACA,oBAAA;EACA,2BAAA;AACA;AACA;EACA,YAAA;AACA;AACA;EACA,qBAAA;EACA,0DAAA;AACA;AACA;CACA,kBAAA;CACA,cAAA;CACA,gBAAA;AACA;AACA;CACA,oBAAA;AACA;AACA;CACA,eAAA;AACA;AACA;CACA,gBAAA;CACA,gBAAA;CACA,iBAAA;AACA;AACA;CACA,gBAAA;AACA;AACA;CACA,aAAA;AACA;AACA;CACA,iBAAA;AACA;AAEA;CACA,+BAAA;AACA;AAEA;CACA,iBAAA;AACA;AAEA;CACA,cAAA;AACA;AAEA;CACA,2BAAA;AACA;AAEA;CACA,eAAA;AACA;AAEA;CACA,aAAA;AACA;AAEA;CACA,cAAA;AACA;AAEA;CACA,eAAA;AACA;AAEA;CACA,yBAAA;AACA;AAEA;CACA,WAAA;AACA;AAEA;CACA,iBAAA;CACA,YAAA;AACA;AACA;CACA,uBAAA;AACA;AACA;CACA,4BAAA;CACA,gCAAA;AACA;AACA;CACA,+BAAA;AACA;AACA;CACA,kBAAA;AACA;AACA;EACA,yBAAA;AACA;AACA;CACA,eAAA;CACA,gBAAA;CACA,qBAAA;CACA,mBAAA;AACA;AACA;CACA,uBAAA;CACA,uBAAA;AACA;AACA;CACA,kKAAA;GACA,oCAAA;AACA;AACA;CACA,yBAAA;CACA,mBAAA;CACA,aAAA;CACA,kBAAA;CACA,gBAAA;CACA,eAAA;CACA,YAAA;AACA;AACA;CACA,qBAAA;CACA,mBAAA;CACA,YAAA;AACA;AACA;CACA,uBAAA;CACA,YAAA;AACA;AACA;CACA,qBAAA;AACA;AACA;CACA,WAAA;AACA;AACA;CACA,yBAAA;CACA,mBAAA;CACA,aAAA;CACA,kBAAA;CACA,gBAAA;CACA,eAAA;CACA,YAAA;AACA;AACA;CACA,iBAAA;AACA;AACA;CACA,uBAAA;CACA,YAAA;AACA;AACA;CACA,YAAA;AACA;AACA;CACA,qBAAA;CACA,mBAAA;CACA,YAAA;AACA;AAEA;CACA,qBAAA;CACA,mBAAA;CACA,YAAA;AACA","file":"add-mashro-widget.vue","sourcesContent":["<template>\r\n\t<div class=\"add_property_widget pb-5\">\r\n\t\t<full_loading></full_loading>\r\n\t\t<div class=\"section-card\">\r\n\t\t\t<div class=\"d-flex align-items-center gap-2 mb-4\">\r\n\t\t\t\t<div class=\"icon-badge\">\r\n\t\t\t\t\t<i class=\"ri-information-line\"></i>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div>\r\n\t\t\t\t\t<h4 class=\"mb-1\">المعلومات الأساسية</h4>\r\n\t\t\t\t\t<small class=\"text-muted\">أضف البيانات الأساسية لمشروعك</small>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div v-if=\"!edit_mashro\" class=\"row g-3\">\r\n\t\t\t\t<div class=\"col-md-3\">\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<select v-model=\"mashro.ready_made\" class=\"form-select form-control border-radius\" \r\n\t\t\t\t\t\t:class=\"check_error('ready_made')\" aria-label=\"Default select example\">\r\n\t\t\t\t\t\t\t<option :value=\"null\" disabled>{{helper.t(\"Select Project Type\")}}</option>\r\n\t\t\t\t\t\t\t<option :value=\"0\">{{helper.t(\"On the map\")}}</option>\r\n\t\t\t\t\t\t\t<option :value=\"1\">{{helper.t(\"Ready-made units\")}}</option>\r\n\t\t\t\t\t\t</select>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"col-md-3\">\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<select v-model=\"mashro.region\" @change=\"region_changed\" class=\"form-select form-control border-radius\" :class=\"check_error('region')\" aria-label=\"Default select example\">\r\n\t\t\t\t\t\t\t<option :value=\"null\" disabled>{{helper.t(\"Select Region\")}}</option>\r\n\t\t\t\t\t\t\t<option v-for=\"region in regions\" :value=\"region\">{{ region.name_ar }}</option>\r\n\t\t\t\t\t\t</select>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div v-if=\"mashro.region\" class=\"col-md-3\">\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<select v-model=\"mashro.city\" @change=\"city_changed\" class=\"form-select form-control border-radius\" :class=\"check_error('city')\" aria-label=\"Default select example\">\r\n\t\t\t\t\t\t\t<option :value=\"null\" disabled>{{helper.t(\"Select City\")}}</option>\r\n\t\t\t\t\t\t\t<option v-for=\"city in cities\" :value=\"city\">{{ city.name_ar }}</option>\r\n\t\t\t\t\t\t</select>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div> \r\n\t\t\t<div class=\"row g-3\">\r\n\t\t\t\t<div class=\"col-md-3\">\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label> {{ helper.t(\"Project Name\") }} </label>\r\n\t\t\t\t\t\t<input\r\n\t\t\t\t\t\t\t:placeholder=\"helper.t('Enter project name')\"\r\n\t\t\t\t\t\t\tv-model=\"mashro.title\"\r\n\t\t\t\t\t\t\ttype=\"text\"\r\n\t\t\t\t\t\t\t:class=\"check_error('title')\"\r\n\t\t\t\t\t\t\t@change=\"validate\"\r\n\t\t\t\t\t\t\tclass=\"form-control border-radius\"\r\n\t\t\t\t\t\t/>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"col-md-3\">\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label> {{ helper.t(\"Address\") }} </label>\r\n\t\t\t\t\t\t<input\r\n\t\t\t\t\t\t\t:placeholder=\"helper.t('Enter project address')\"\r\n\t\t\t\t\t\t\tv-model=\"mashro.address\"\r\n\t\t\t\t\t\t\ttype=\"text\"\r\n\t\t\t\t\t\t\t:class=\"check_error('address')\"\r\n\t\t\t\t\t\t\t@change=\"validate\"\r\n\t\t\t\t\t\t\tclass=\"form-control border-radius\"\r\n\t\t\t\t\t\t/>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"col-md-3\">\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label> {{ helper.t(\"Total Units\") }} </label>\r\n\t\t\t\t\t\t<input\r\n\t\t\t\t\t\t\t:placeholder=\"helper.t('Enter No. of Units')\"\r\n\t\t\t\t\t\t\tclass=\"form-control border-radius\"\r\n\t\t\t\t\t\t\tv-model=\"mashro.units\"\r\n\t\t\t\t\t\t\ttype=\"number\"\r\n\t\t\t\t\t\t\tstep=\"1\"\r\n\t\t\t\t\t\t\tmin=\"0\"\r\n\t\t\t\t\t\t\t:class=\"check_error('units')\"\r\n\t\t\t\t\t\t\t@change=\"validate();\"\r\n\t\t\t\t\t\t/>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"col-md-3\">\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label> {{ helper.t(\"Project Brochure\") }} </label>\r\n\t\t\t\t\t\t<label\r\n\t\t\t\t\t\t\t@click=\"onPickFile\"\r\n\t\t\t\t\t\t\tclass=\"form-control border-radius d-flex justify-content-between align-items-center\"\r\n\t\t\t\t\t\t\tstyle=\"cursor:pointer;\">\r\n\t\t\t\t\t\t\t<template>\r\n\t\t\t\t\t\t\t\t<small v-if=\"!mashro.manual_file\" class=\"text-placeholder-color fw-normal\">\r\n\t\t\t\t\t\t\t\t\t{{ helper.t('No file selected') }}\r\n\t\t\t\t\t\t\t\t</small>\r\n\t\t\t\t\t\t\t\t<small v-else class=\"text-placeholder-color\">\r\n\t\t\t\t\t\t\t\t\t{{ mashro.manual_file.file.substring(0,12) + \"...\" + mashro.manual_file.file.substring(mashro.manual_file.file.length-4) }}\r\n\t\t\t\t\t\t\t\t</small>\r\n\t\t\t\t\t\t\t\t<small class=\"btn btn-primary btn-sm\">\r\n\t\t\t\t\t\t\t\t\t{{ helper.t(\"Select PDF File\") }}\r\n\t\t\t\t\t\t\t\t</small>\r\n\t\t\t\t\t\t\t</template>\r\n\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t<input\r\n\t\t\t\t\t\t\tclass=\"d-none\"\r\n\t\t\t\t\t\t\ttype=\"file\"\r\n\t\t\t\t\t\t\tref=\"pdfFileInput\"\r\n\t\t\t\t\t\t\t:class=\"check_error('manual_file')\"\r\n\t\t\t\t\t\t\taccept=\"application/pdf\"\r\n\t\t\t\t\t\t\t@input=\"pdfPickFile\"\r\n\t\t\t\t\t\t/>\r\n\t\t\t\t\t\t<a v-if=\"edit_mashro && mashro.manual_doc\" :href=\"mashro.manual_doc\" target=\"_blank\">\r\n\t\t\t\t\t\t\t<small class=\"\">\r\n\t\t\t\t\t\t\t\t<img src=\"/assets/maalek/images/pdf.svg\" style=\"height: 30px;\"/>\r\n\t\t\t\t\t\t\t\t{{ helper.t(\"Project Brochure\") }}\r\n\t\t\t\t\t\t\t</small>\r\n\t\t\t\t\t\t</a>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"col-md-3\">\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label> {{ helper.t(\"Min Price\") }} </label>\r\n\t\t\t\t\t\t<input\r\n\t\t\t\t\t\t\t:placeholder=\"helper.t('Enter Min Price')\"\r\n\t\t\t\t\t\t\tclass=\"form-control border-radius\"\r\n\t\t\t\t\t\t\tv-model=\"mashro.price_min\"\r\n\t\t\t\t\t\t\ttype=\"number\"\r\n\t\t\t\t\t\t\tstep=\"1\"\r\n\t\t\t\t\t\t\tmin=\"0\"\r\n\t\t\t\t\t\t\t:class=\"check_error('price_min')\"\r\n\t\t\t\t\t\t\t@change=\"validate();\"\r\n\t\t\t\t\t\t/>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"col-md-3\">\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label> {{ helper.t(\"Max Price\") }} </label>\r\n\t\t\t\t\t\t<input\r\n\t\t\t\t\t\t\t:placeholder=\"helper.t('Enter Max Price')\"\r\n\t\t\t\t\t\t\tclass=\"form-control border-radius\"\r\n\t\t\t\t\t\t\tv-model=\"mashro.price_max\"\r\n\t\t\t\t\t\t\ttype=\"number\"\r\n\t\t\t\t\t\t\tstep=\"1\"\r\n\t\t\t\t\t\t\tmin=\"0\"\r\n\t\t\t\t\t\t\t:class=\"check_error('price_max')\"\r\n\t\t\t\t\t\t\t@change=\"validate();\"\r\n\t\t\t\t\t\t/>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"col-md-3\">\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label> {{ helper.t(\"Min Area\") }} </label>\r\n\t\t\t\t\t\t<input\r\n\t\t\t\t\t\t\t:placeholder=\"helper.t('Enter Min Area')\"\r\n\t\t\t\t\t\t\tclass=\"form-control border-radius\"\r\n\t\t\t\t\t\t\tv-model=\"mashro.area_min\"\r\n\t\t\t\t\t\t\ttype=\"number\"\r\n\t\t\t\t\t\t\tstep=\"1\"\r\n\t\t\t\t\t\t\tmin=\"0\"\r\n\t\t\t\t\t\t\t:class=\"check_error('area_min')\"\r\n\t\t\t\t\t\t\t@change=\"validate();\"\r\n\t\t\t\t\t\t/>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"col-md-3\">\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label> {{ helper.t(\"Max Area\") }} </label>\r\n\t\t\t\t\t\t<input\r\n\t\t\t\t\t\t\t:placeholder=\"helper.t('Enter Max Area')\"\r\n\t\t\t\t\t\t\tclass=\"form-control border-radius\"\r\n\t\t\t\t\t\t\tv-model=\"mashro.area_max\"\r\n\t\t\t\t\t\t\ttype=\"number\"\r\n\t\t\t\t\t\t\tstep=\"1\"\r\n\t\t\t\t\t\t\tmin=\"0\"\r\n\t\t\t\t\t\t\t:class=\"check_error('area_max')\"\r\n\t\t\t\t\t\t\t@change=\"validate();\"\r\n\t\t\t\t\t\t/>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t\t<div class=\"section-card\">\r\n\t\t\t<div class=\"d-flex align-items-center gap-2 mb-4\">\r\n\t\t\t\t<div class=\"icon-badge\">\r\n\t\t\t\t\t<i class=\"ri-contacts-book-line\"></i>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div>\r\n\t\t\t\t\t<h4 class=\"mb-1\">{{ helper.t(\"Contact Info\") }}</h4>\r\n\t\t\t\t\t<small class=\"text-muted\">{{ helper.t(\"Mention contact information for your project\") }}</small>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"row g-3\">\r\n\t\t\t\t<div v-if=\"members.length > 0\" class=\"col-md-4\">\r\n\t\t\t\t\t<div v-if=\"!edit_mashro\" class=\"form-group\">\r\n\t\t\t\t\t\t<label>{{helper.t(\"Project Manager\")}}</label>\r\n\t\t\t\t\t\t<select\r\n\t\t\t\t\t\t\tv-model=\"mashro.to_member\"\r\n\t\t\t\t\t\t\t:class=\"mashro.to_member?'':''\"\r\n\t\t\t\t\t\t\t@change=\"member_changed\"\r\n\t\t\t\t\t\t\tclass=\"form-select form-control border-radius\" aria-label=\"Default select example\">\r\n\t\t\t\t\t\t\t<option :value=\"null\">{{ helper.t('Managed by company\\'s main account') }}</option>\r\n\t\t\t\t\t\t\t<option v-for=\"member in members\" :value=\"member\">{{ member['full_name'] }} - (0{{ member['member'].substring(4) }})</option>\r\n\t\t\t\t\t\t</select>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div v-else class=\"form-group\">\r\n\t\t\t\t\t\t<label>{{helper.t(\"Project Manager\")}}</label>\r\n\t\t\t\t\t\t<input\r\n\t\t\t\t\t\t\tv-model=\"mashro.manager_user_fullname\"\r\n\t\t\t\t\t\t\ttype=\"text\"\r\n\t\t\t\t\t\t\tdisabled\r\n\t\t\t\t\t\t\tclass=\"form-control border-radius\"\r\n\t\t\t\t\t\t/>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div v-else-if=\"agencies.length > 0 && !edit_mashro\" class=\"col-md-4\">\r\n\t\t\t\t\t<div v-if=\"agencies.length > 1\" class=\"form-group\">\r\n\t\t\t\t\t\t<label>{{helper.t(\"Select Developer\")}}</label>\r\n\t\t\t\t\t\t<select \r\n\t\t\t\t\t\t\tv-model=\"mashro.for_agency\"\r\n\t\t\t\t\t\t\tclass=\"form-select form-control border-radius\" aria-label=\"Default select example\">\r\n\t\t\t\t\t\t\t<option value=\"\">{{helper.t(\"Select Developer\")}}</option>\r\n\t\t\t\t\t\t\t<option v-for=\"agency in agencies\" :value=\"agency\">{{ agency.full_name }} - (0{{ agency.agency.substring(4) }})</option>\r\n\t\t\t\t\t\t</select>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div v-else-if=\"agencies.length > 0\" class=\"form-group\">\r\n\t\t\t\t\t\t<label>{{helper.t(\"Developer\")}}</label>\r\n\t\t\t\t\t\t<!-- agency.full_name -->\r\n\t\t\t\t\t\t<input\r\n\t\t\t\t\t\t\tv-model=\"mashro.for_agency['full_name']\"\r\n\t\t\t\t\t\t\ttype=\"text\"\r\n\t\t\t\t\t\t\tdisabled\r\n\t\t\t\t\t\t\tclass=\"form-control border-radius\"\r\n\t\t\t\t\t\t/>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div v-else-if=\"edit_mashro\" class=\"col-md-4\">\r\n\t\t\t\t\t<div v-if=\"mashro.owned\" class=\"form-group\">\r\n\t\t\t\t\t\t<label>{{helper.t(\"Project Manager\")}}</label>\r\n\t\t\t\t\t\t<!-- agency.full_name -->\r\n\t\t\t\t\t\t<input\r\n\t\t\t\t\t\t\tv-model=\"mashro.manager_user_fullname\"\r\n\t\t\t\t\t\t\ttype=\"text\"\r\n\t\t\t\t\t\t\tdisabled\r\n\t\t\t\t\t\t\tclass=\"form-control border-radius\"\r\n\t\t\t\t\t\t/>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div v-else class=\"form-group\">\r\n\t\t\t\t\t\t<label>{{helper.t(\"Developer\")}}</label>\r\n\t\t\t\t\t\t<!-- agency.full_name -->\r\n\t\t\t\t\t\t<input\r\n\t\t\t\t\t\t\tv-model=\"mashro.owner_fullname\"\r\n\t\t\t\t\t\t\ttype=\"text\"\r\n\t\t\t\t\t\t\tdisabled\r\n\t\t\t\t\t\t\tclass=\"form-control border-radius\"\r\n\t\t\t\t\t\t/>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"col-md-4\">\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label> {{ helper.t(\"Contact No\") }} </label>\r\n\t\t\t\t\t\t<input\r\n\t\t\t\t\t\t\tv-model=\"mashro.contact_no\"\r\n\t\t\t\t\t\t\ttype=\"text\"\r\n\t\t\t\t\t\t\t:class=\"check_error('contact_no')\"\r\n\t\t\t\t\t\t\t@change=\"validate\"\r\n\t\t\t\t\t\t\tclass=\"form-control border-radius\"\r\n\t\t\t\t\t\t/>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"col-md-4\">\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label> {{ helper.t(\"Contact Email\") }} </label>\r\n\t\t\t\t\t\t<input\r\n\t\t\t\t\t\t\tv-model=\"mashro.contact_email\"\r\n\t\t\t\t\t\t\ttype=\"text\"\r\n\t\t\t\t\t\t\t:class=\"check_error('contact_email')\"\r\n\t\t\t\t\t\t\t@change=\"validate\"\r\n\t\t\t\t\t\t\tclass=\"form-control border-radius\"\r\n\t\t\t\t\t\t/>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t\r\n\t\t\t<div class=\"d-flex align-items-center gap-2 mb-4\">\r\n\t\t\t\t<div>\r\n\t\t\t\t\t<small class=\"text-muted\">{{ helper.t(\"Select Prefered Coomunication Medium\") }}</small>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"row g-3\">\r\n\t\t\t\t<div class=\"col-2\">\r\n\t\t\t\t\t<div @click=\" set_communication('phone')\"\r\n\t\t\t\t\tclass=\"facility_type\"\r\n\t\t\t\t\t:class=\"mashro.phone?'selected':''\">\r\n\t\t\t\t\t\t<i class=\"ri-phone-fill\"></i>\r\n\t\t\t\t\t\t<div>{{ helper.t(\"Phone\") }}</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"col-2\">\r\n\t\t\t\t\t<div @click=\"set_communication('whatsapp')\"\r\n\t\t\t\t\tclass=\"facility_type\"\r\n\t\t\t\t\t:class=\"mashro.whatsapp?'selected':''\">\r\n\t\t\t\t\t\t<i class=\"ri-whatsapp-fill\"></i>\r\n\t\t\t\t\t\t<div>{{ helper.t(\"Whatsapp\") }}</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"col-2\">\r\n\t\t\t\t\t<div @click=\"set_communication('email')\"\r\n\t\t\t\t\tclass=\"facility_type\"\r\n\t\t\t\t\t:class=\"mashro.email?'selected':''\">\r\n\t\t\t\t\t\t<i class=\"ri-mail-fill\"></i>\r\n\t\t\t\t\t\t<div>{{ helper.t(\"Email\") }}</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t\t<div class=\"section-card features-content\">\r\n\t\t\t<div class=\"d-flex align-items-center gap-2 mb-4\">\r\n\t\t\t\t<div class=\"icon-badge\">\r\n\t\t\t\t\t<i class=\"ri-information-line\"></i>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div>\r\n\t\t\t\t\t<h4 class=\"mb-1\">{{ helper.t(\"Property Types\") }}</h4>\r\n\t\t\t\t\t<small class=\"text-muted\">اختر الوحدات العقارية المتوفرة في المشروع</small>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"row g-3\">\r\n\t\t\t\t<div class=\"col-2\" v-for=\"property_type in mashro_property_types\">\r\n\t\t\t\t\t<div class=\"property_type\" \r\n\t\t\t\t\t\t:class=\"mashro.property_types[property_type]?'selected':''\"\r\n\t\t\t\t\t\t@click=\"set_property_type(property_type,true)\">\r\n\t\t\t\t\t\t<img :src=\"global.global_params.legend_icons[property_type]\" />\r\n\t\t\t\t\t\t<div>{{ helper.t(property_type+\"s\") }}</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t\t<div class=\"section-card features-content\">\r\n\t\t\t<div class=\"d-flex align-items-center gap-2 mb-4\">\r\n\t\t\t\t<div class=\"icon-badge\">\r\n\t\t\t\t\t<i class=\"ri-shield-check-line\"></i>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div>\r\n\t\t\t\t\t<h4 class=\"mb-1\">{{ helper.t(\"Guarantees\") }}</h4>\r\n\t\t\t\t\t<small class=\"text-muted\">أضف مدة الضمان لكل عنصر</small>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"row g-3\">\r\n\t\t\t\t<div v-for=\"guarantee_type in mashro_guarantee_types\" class=\"col-lg-3 col-md-4\">\r\n\t\t\t\t\t<div :class=\"mashro.guarantees[guarantee_type] > 0?'text-success':''\">\r\n\t\t\t\t\t\t\r\n\t\t\t\t\t\t<div class=\"form-check form-switch\">\r\n\t\t\t\t\t\t\t<input class=\"form-check-input\" type=\"checkbox\"\r\n\t\t\t\t\t\t\t\t@change=\"set_guarantee_type(guarantee_type)\"\r\n\t\t\t\t\t\t\t\t:checked=\"mashro.guarantees[guarantee_type] > 0\"\r\n\t\t\t\t\t\t\t>\r\n\t\t\t\t\t\t\t<label class=\"form-check-label\" for=\"flexSwitchCheckDefault\">{{ helper.t(\"g_\"+guarantee_type.toLowerCase()) }}</label>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"input-group\">\r\n\t\t\t\t\t\t<input\r\n\t\t\t\t\t\t\t:name=\"guarantee_type\"\r\n\t\t\t\t\t\t\t@click=\"mashro.guarantees[guarantee_type] == 0?set_guarantee_type(guarantee_type,true):null\"\r\n\t\t\t\t\t\t\tclass=\"form-control border-radius\"\r\n\t\t\t\t\t\t\t:class=\"mashro.guarantees[guarantee_type] == 0?'bg-light text-muted':'border-1 border-success'\"\r\n\t\t\t\t\t\t\t:readonly=\"mashro.guarantees[guarantee_type] == 0\"\r\n\t\t\t\t\t\t\tv-model=\"mashro.guarantees[guarantee_type]\"\r\n\t\t\t\t\t\t\ttype=\"number\"\r\n\t\t\t\t\t\t\tstep=\"1\"\r\n\t\t\t\t\t\t\tmin=\"1\"\r\n\t\t\t\t\t\t>\r\n\t\t\t\t\t\t<span class=\"input-group-text\" id=\"basic-addon2\"\r\n\t\t\t\t\t\t\t@click=\"mashro.guarantees[guarantee_type] == 0?set_guarantee_type(guarantee_type,true):null\">\r\n\t\t\t\t\t\t\t{{ helper.t(\"Year\") }}\r\n\t\t\t\t\t\t</span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t\t<div class=\"section-card\">\r\n\t\t\t<div class=\"features-content\">\r\n\t\t\t\t<div class=\"d-flex align-items-center gap-2 mb-4\">\r\n\t\t\t\t\t<div class=\"icon-badge\">\r\n\t\t\t\t\t\t<i class=\"ri-community-line\"></i>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div>\r\n\t\t\t\t\t\t<h4 class=\"mb-1\">{{ helper.t(\"Facilities\") }}</h4>\r\n\t\t\t\t\t\t<small class=\"text-muted\">اختر المرافق المتوفرة في المشروع</small>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"row g-3\">\r\n\t\t\t\t\t<div class=\"col-2\">\r\n\t\t\t\t\t\t<div @click=\"mashro.masjid = !mashro.masjid;\"\r\n\t\t\t\t\t\tclass=\"facility_type\"\r\n\t\t\t\t\t\t:class=\"mashro.masjid?'selected':''\">\r\n\t\t\t\t\t\t\t<i class=\"fa-solid fa-mosque fa-lg\"></i>\r\n\t\t\t\t\t\t\t<div>{{ helper.t(\"Masjid\") }}</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"col-2\">\r\n\t\t\t\t\t\t<div @click=\"mashro.health = !mashro.health;\"\r\n\t\t\t\t\t\tclass=\"facility_type\"\r\n\t\t\t\t\t\t:class=\"mashro.health?'selected':''\">\r\n\t\t\t\t\t\t\t<i class=\"fa-solid fa-heart-pulse fa-lg\"></i>\r\n\t\t\t\t\t\t\t<div>{{ helper.t(\"Health\") }}</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"col-2\">\r\n\t\t\t\t\t\t<div @click=\"mashro.shopping = !mashro.shopping;\"\r\n\t\t\t\t\t\tclass=\"facility_type\"\r\n\t\t\t\t\t\t:class=\"mashro.shopping?'selected':''\">\r\n\t\t\t\t\t\t\t<i class=\"fa-solid fa-cart-shopping fa-lg\"></i>\r\n\t\t\t\t\t\t\t<div>{{ helper.t(\"Shopping\") }}</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"col-2\">\r\n\t\t\t\t\t\t<div @click=\"mashro.park = !mashro.park;\"\r\n\t\t\t\t\t\tclass=\"facility_type\"\r\n\t\t\t\t\t\t:class=\"mashro.park?'selected':''\">\r\n\t\t\t\t\t\t\t<i class=\"fa-solid fa-cart-shopping fa-lg\"></i>\r\n\t\t\t\t\t\t\t<div>{{ helper.t(\"Park\") }}</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"col-2\">\r\n\t\t\t\t\t\t<div @click=\"mashro.school_male = !mashro.school_male;\"\r\n\t\t\t\t\t\tclass=\"facility_type\"\r\n\t\t\t\t\t\t:class=\"mashro.school_male?'selected':''\">\r\n\t\t\t\t\t\t\t<i class=\"fa-solid fa-graduation-cap fa-lg\"></i>\r\n\t\t\t\t\t\t\t<div>{{ helper.t(\"Male School\") }}</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"col-2\">\r\n\t\t\t\t\t\t<div @click=\"mashro.school_female = !mashro.school_female;\"\r\n\t\t\t\t\t\tclass=\"facility_type\"\r\n\t\t\t\t\t\t:class=\"mashro.school_female?'selected':''\">\r\n\t\t\t\t\t\t\t<i class=\"fa-solid fa-graduation-cap fa-lg\"></i>\r\n\t\t\t\t\t\t\t<div>{{ helper.t(\"Female School\") }}</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t\t<div class=\"section-card\">\r\n\t\t\t<div class=\"features-content\">\r\n\t\t\t\t<div class=\"row\">\r\n\t\t\t\t\t<div class=\"col-lg-12\">\r\n\t\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t\t<div class=\"d-flex align-items-center gap-2 mb-4\">\r\n\t\t\t\t\t\t\t\t<div class=\"icon-badge\">\r\n\t\t\t\t\t\t\t\t\t<i class=\"ri-youtube-fill\"></i>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t<div>\r\n\t\t\t\t\t\t\t\t\t<h4 class=\"mb-1\">{{ helper.t(\"Video\") }}</h4>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t<div class=\"col-md-6\">\r\n\t\t\t\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t\t\t\t<input\r\n\t\t\t\t\t\t\t\t\t\tplaceholder=\"أضف  فيديو المشروع (رابط يوتيوب)\"\r\n\t\t\t\t\t\t\t\t\t\tv-model=\"mashro.video\"\r\n\t\t\t\t\t\t\t\t\t\ttype=\"text\"\r\n\t\t\t\t\t\t\t\t\t\t:class=\"check_error('video')\"\r\n\t\t\t\t\t\t\t\t\t\t@change=\"validate\"\r\n\t\t\t\t\t\t\t\t\t\tclass=\"form-control border-radius\"\r\n\t\t\t\t\t\t\t\t\t/>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t<div class=\"d-flex align-items-center gap-2 mb-4\">\r\n\t\t\t\t\t\t\t\t<div class=\"icon-badge\">\r\n\t\t\t\t\t\t\t\t\t<i class=\"fa-regular fa-images\"></i>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t<div>\r\n\t\t\t\t\t\t\t\t\t<h4 class=\"mb-1\">{{ helper.t(\"Images\") }}</h4>\r\n\t\t\t\t\t\t\t\t\t<small class=\"text-muted\">أضف صور المشروع</small>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t<div class=\"row images-container\"\r\n\t\t\t\t\t\t\t\t:class=\"check_error('main_image_index')\">\r\n\t\t\t\t\t\t\t\t<div v-for=\"(image, image_index) in mashro.images\"\r\n\t\t\t\t\t\t\t\tclass=\"col-sm-6 col-md-3 image-input-container\">\r\n\t\t\t\t\t\t\t\t\t<div\r\n\t\t\t\t\t\t\t\t\t\t@click=\"mashro.main_image_index = image_index\"\r\n\t\t\t\t\t\t\t\t\t\tclass=\"imagePreviewWrapper\"\r\n\t\t\t\t\t\t\t\t\t\t:style=\"{\r\n\t\t\t\t\t\t\t\t\t\t'background-image': `url(${\r\n\t\t\t\t\t\t\t\t\t\t\timage.link ? image.link : image.data\r\n\t\t\t\t\t\t\t\t\t\t})`,\r\n\t\t\t\t\t\t\t\t\t\t}\"\r\n\t\t\t\t\t\t\t\t\t></div>\r\n\t\t\t\t\t\t\t\t\t<i\r\n\t\t\t\t\t\t\t\t\t\t@click=\"remove_image(image)\"\r\n\t\t\t\t\t\t\t\t\t\tclass=\"fa-solid fa-trash fa-2x delete text-danger\"\r\n\t\t\t\t\t\t\t\t\t></i>\r\n\t\t\t\t\t\t\t\t\t<i\r\n\t\t\t\t\t\t\t\t\t\tv-if=\"image_index == mashro.main_image_index\"\r\n\t\t\t\t\t\t\t\t\t\tclass=\"fa-solid fa-square-check fa-2x main text-primary\"\r\n\t\t\t\t\t\t\t\t\t></i>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t<div class=\"col-lg-3 image-input-container\">\r\n\t\t\t\t\t\t\t\t\t<label\r\n\t\t\t\t\t\t\t\t\t\tfor=\"file_parent\"\r\n\t\t\t\t\t\t\t\t\t\tclass=\"imageEmptyWrapper\"\r\n\t\t\t\t\t\t\t\t\t></label>\r\n\t\t\t\t\t\t\t\t\t<input\r\n\t\t\t\t\t\t\t\t\t\tid=\"file_parent\"\r\n\t\t\t\t\t\t\t\t\t\tclass=\"input-file\"\r\n\t\t\t\t\t\t\t\t\t\tref=\"file_input_parent\"\r\n\t\t\t\t\t\t\t\t\t\ttype=\"file\"\r\n\t\t\t\t\t\t\t\t\t\t@input=\"pickFile\"\r\n\t\t\t\t\t\t\t\t\t\taccept=\"image/png, image/gif, image/jpeg\"\r\n\t\t\t\t\t\t\t\t\t\tmultiple\r\n\t\t\t\t\t\t\t\t\t/>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t\t<div class=\"section-card\">\r\n\t\t\t<div class=\"features-content\">\r\n\t\t\t\t<div class=\"row\" :class=\"check_error('location')\">\r\n\t\t\t\t\t<div class=\"d-flex align-items-center gap-2 mb-4\">\r\n\t\t\t\t\t\t<div class=\"icon-badge\">\r\n\t\t\t\t\t\t\t<i class=\"ri-map-pin-line\"></i>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div>\r\n\t\t\t\t\t\t\t<h4 class=\"mb-1\">{{ helper.t(\"Project Boundries\") }}</h4>\r\n\t\t\t\t\t\t\t<small class=\"text-muted\">حدد موقع المشروع على الخريطة</small>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"col-12\" dir=\"ltr\">\r\n\t\t\t\t\t\t<div id=\"map\" style=\"height: 500px;\"></div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"row\">\r\n\t\t\t\t\t<div class=\"col show-hand text-center\">\r\n\t\t\t\t\t\t<a class=\"btn default-btn mt-4 show-hand\" @click=\"confirm_save();\">\r\n\t\t\t\t\t\t\t<p>{{ helper.t(this.edit_mashro?\"Update Project\":\"Save & Publish Project\") }}</p>\r\n\t\t\t\t\t\t</a>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</div>\r\n</template>\r\n\r\n<script>\r\n\timport * as global from \"../../js/global\";\r\n\timport * as helper from \"../../js/helper\";\r\n\timport full_loading from \"../components/full-loading.vue\";\r\n\texport default{\r\n\t\tcomponents: {\r\n\t\t\tfull_loading:full_loading,\r\n\t\t},\r\n\t\tname:'add_mashro_widget',\r\n\t\tprops: {\r\n\t\t\tmashro_json: {\r\n\t\t\t\ttype: String,\r\n\t\t\t},\r\n\t\t\tmashro_name: {\r\n\t\t\t\ttype: String,\r\n\t\t\t},\r\n\t\t\towner_no: {\r\n\t\t\t\ttype: String,\r\n\t\t\t},\r\n\t\t\towner_email: {\r\n\t\t\t\ttype: String,\r\n\t\t\t},\r\n\t\t\tregions_json: {\r\n\t\t\t},\r\n\t\t},\r\n\t\tdata() {\r\n\t\t\treturn {\r\n\t\t\t\tglobal,\r\n\t\t\t\thelper,\r\n\t\t\t\tfrappe,\r\n\t\t\t\tregions:[],\r\n\t\t\t\tcities:[],\r\n\t\t\t\tready:false,\r\n\t\t\t\tloading:false,\r\n\t\t\t\tagreement:null,\r\n\t\t\t\tpolicy_agreed:false,\r\n\t\t\t\tcurrent_step: 0,\r\n                mashro_guarantee_types: global.mashro_constants.mashro_guarantee_types,\r\n                mashro_property_types: global.mashro_constants.mashro_property_types,\r\n\t\t\t\tagencies:[],\r\n\t\t\t\tmembers: [],\r\n\t\t\t\timages:[],\r\n\t\t\t\tmain_image_index: 0,\r\n\t\t\t\tto_agency: null,\r\n\t\t\t\tedit_property: null,\r\n\t\t\t\tmashro: new global.Mashro(),\r\n                edit_mashro: null,\r\n\t\t\t\tis_nafath_verified:false,\r\n\t\t\t\tad_license_number: \"\",\r\n\t\t\t\tadvertiser_id: null,\r\n\t\t\t\tborders:false,\r\n\t\t\t\trer_borders:false,\r\n\t\t\t\tdrawnItems: new L.FeatureGroup(),\r\n\t\t\t\tmanual_file: null,\r\n\t\t\t}\r\n\t\t},\r\n\t\tasync created(){\r\n\t\t\tif(this.mashro_json != undefined){\r\n\t\t\t    this.edit_mashro = JSON.parse(this.mashro_json);\r\n\t\t\t\tthis.mashro.from_map(this.edit_mashro);\t\t\t\t\r\n\t\t\t}\r\n\t\t\tif(this.regions_json != undefined){\r\n\t\t\t    this.regions = JSON.parse(this.regions_json);\t\t\t\r\n\t\t\t}\r\n\t\t},\r\n\t\tasync mounted(){\r\n\t\t\tglobal.emitter.emit(\"show-full-loading\");\r\n\t\t\tif(!this.edit_mashro){\r\n\t\t\t\tif(frappe.user_roles.includes('Developer')){\r\n\t\t\t\t\tthis.mashro.contact_no = '0' + frappe.session_user.substring(4);\r\n\t\t\t\t\tthis.mashro.contact_email = this.owner_email;\r\n\t\t\t\t\tthis.load_members();\r\n\t\t\t\t}else if(frappe.user_roles.includes('Member')){\r\n\t\t\t\t\tthis.mashro.contact_no = '0' + frappe.session_user.substring(4);\r\n\t\t\t\t\tthis.mashro.contact_email = frappe.session_user_email;\r\n\t\t\t\t\tthis.load_agencies();\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t\t\r\n\t\t\tthis.setup_map();\r\n\t\t\tthis.ready = true;\r\n\t\t\tglobal.emitter.emit(\"hide-full-loading\");\r\n\r\n\t\t\tconst inputs = document.getElementsByClassName(\"number-field\");\r\n\t\t\tfor (let i = 0; i < inputs.length; i++) {\r\n\t\t\t\tinputs[i].addEventListener(\"focus\", function () {\r\n\t\t\t\t\tthis.value = this.value.replace(/,/g, \"\");\r\n\t\t\t\t});\r\n\r\n\t\t\t\tinputs[i].addEventListener(\"blur\", function () {\r\n\t\t\t\t\tlet value = this.value.replace(/,/g, \"\");\r\n\r\n\t\t\t\t\tif (!isNaN(value) && value !== \"\") {\r\n\t\t\t\t\t\tthis.value = Number(value).toLocaleString(\"en-US\");\r\n\t\t\t\t\t}\r\n\t\t\t\t});\r\n\t\t\t}\r\n\t\t},\r\n\t\tmethods: {\r\n\t\t\tload_members: async function(){\r\n\t\t\t\tglobal.emitter.emit(\"show-full-loading\");\r\n\t\t\t\tthis.is_loading = true;\r\n\t\t\t\tlet params = {\r\n\t\t\t\t\t'mashro_managers':1\r\n\t\t\t\t};\r\n\t\t\t\tlet url = \"/api/method/maalek.api.get_agency_members\";\r\n\t\t\t\tlet res = await $.ajax({\r\n\t\t\t\t\turl: url,\r\n\t\t\t\t\ttype: \"GET\",\r\n\t\t\t\t\tdata: params\r\n\t\t\t\t});\r\n\t\t\t\tfor (let index = 0; index < res.message.length; index++) {\r\n\t\t\t\t\tres.message[index]['creation'] = new Date(res.message[index]['creation']);\r\n\t\t\t\t\tthis.members.push(res.message[index]);\r\n\t\t\t\t}\r\n\t\t\t\tthis.is_loading = false;\r\n\t\t\t\tglobal.emitter.emit(\"hide-full-loading\");\r\n\t\t\t},\r\n\t\t\tload_agencies: async function(){\r\n\t\t\t\tglobal.emitter.emit(\"show-full-loading\");\r\n\t\t\t\tthis.is_loading = true;\r\n\t\t\t\tlet params = {\r\n\t\t\t\t\t'for_mashro':1\r\n\t\t\t\t};\r\n\t\t\t\tlet url = \"/api/method/maalek.api.get_registered_agencies\";\r\n\t\t\t\tlet res = await $.ajax({\r\n\t\t\t\t\turl: url,\r\n\t\t\t\t\ttype: \"GET\",\r\n\t\t\t\t\tdata: params\r\n\t\t\t\t});\r\n\t\t\t\tfor (let index = 0; index < res.message.length; index++) {\r\n\t\t\t\t\tres.message[index]['creation'] = new Date(res.message[index]['creation']);\r\n\t\t\t\t\tthis.agencies.push(res.message[index]);\r\n\t\t\t\t}\r\n\t\t\t\tif(this.agencies.length == 1){\r\n\t\t\t\t\tthis.mashro.for_agency = this.agencies[0];\r\n\t\t\t\t}\r\n\t\t\t\tthis.is_loading = false;\r\n\t\t\t\tglobal.emitter.emit(\"hide-full-loading\");\r\n\t\t\t},\r\n\t\t\tregion_changed: async function(){\r\n\t\t\t\tglobal.emitter.emit(\"show-full-loading\");\r\n\t\t\t\tthis.cities = [];\r\n\t\t\t\tthis.mashro.city = null;\r\n\t\t\t\tthis.is_loading = true;\r\n\t\t\t\tlet params = {\r\n\t\t\t\t\t'region_id':this.mashro.region.region_id\r\n\t\t\t\t};\r\n\t\t\t\tlet url = \"/api/method/maalek.api.get_cities\";\r\n\t\t\t\tlet res = await $.ajax({\r\n\t\t\t\t\turl: url,\r\n\t\t\t\t\ttype: \"GET\",\r\n\t\t\t\t\tdata: params\r\n\t\t\t\t});\r\n\t\t\t\tfor (let index = 0; index < res.message.length; index++) {\r\n\t\t\t\t\tthis.cities.push(res.message[index]);\r\n\t\t\t\t}\r\n\t\t\t\tthis.map.setView([this.mashro.region.lat, this.mashro.region.lng], 10);\r\n\t\t\t\tthis.is_loading = false;\r\n\t\t\t\tglobal.emitter.emit(\"hide-full-loading\");\r\n\t\t\t},\r\n\t\t\tcity_changed: async function(){\r\n\t\t\t\tthis.map.setView([this.mashro.city.lat, this.mashro.city.lng], 13);\r\n\t\t\t},\r\n\t\t\tconfirm_save: async function () {\r\n\t\t\t\t// this.save_mashro();\r\n\t\t\t\t// return;\r\n\t\t\t\tif(!this.mashro.validate()){\r\n\t\t\t\t\tconsole.log(this.mashro.errors);\r\n\t\t\t\t\tbootbox.alert({\r\n\t\t\t\t\t\ttitle: helper.t(\"Error\"),\r\n\t\t\t\t\t\tmessage:`<div class=\"alert alert-danger\" role=\"alert\">\r\n\t\t\t\t\t\t\t\t\t`+helper.t(\"Please fix the issues marked in Red Color\")+`\r\n\t\t\t\t\t\t\t\t</div>`,\r\n\t\t\t\t\t\tsize: 'large',\r\n\t\t\t\t\t\tbuttons: {\r\n\t\t\t\t\t\t\tok: {\r\n\t\t\t\t\t\t\t\tlabel: helper.t(\"Ok\"),\r\n\t\t\t\t\t\t\t\tclassName: 'btn default-btn'\r\n\t\t\t\t\t\t\t}\r\n\t\t\t\t\t\t},\r\n\t\t\t\t\t\t// callback: (results) => results?this.save_mashro():console.log(\"cancel\"),\r\n\t\t\t\t\t});\r\n\t\t\t\t\treturn;\r\n\t\t\t\t}\r\n\t\t\t\tthis.save_mashro();\r\n\t\t\t},\r\n\t\t\tsave_mashro: async function(){\r\n\t\t\t\ttry {\r\n\t\t\t\t\tglobal.emitter.emit(\"show-full-loading\");\r\n\t\t\t\t\t\r\n\t\t\t\t\tconst geojson = this.drawnItems.toGeoJSON();\r\n\t\t\t\t\tthis.mashro.location = geojson;\r\n\r\n\t\t\t\t\tlet params = this.mashro;\r\n\t\t\t\t\tlet res = await $.ajax({\r\n\t\t\t\t\t\theaders: { 'X-Frappe-CSRF-Token': frappe.csrf_token },\r\n\t\t\t\t\t\turl: \"/api/method/maalek.api.add_mashro\",\r\n\t\t\t\t\t\ttype: \"POST\",\r\n\t\t\t\t\t\tdata: JSON.stringify(params)\r\n\t\t\t\t\t});\r\n\t\t\t\t\tthis.mashro.name = res.message;\r\n\t\t\t\t\tglobal.emitter.emit(\"hide-full-loading\");\r\n\t\t\t\t\thelper.showSuccess(this.edit_mashro?\"Project Updated\":\"Project Saved\",()=>{\r\n\t\t\t\t\t\tif(this.edit_mashro){\r\n\t\t\t\t\t\t\tlocation.reload();\r\n\t\t\t\t\t\t}else{\r\n\t\t\t\t\t\t\tlocation.replace(\"/account/my-projects\");\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t});\r\n\t\t\t\t} catch (e) {\r\n\t\t\t\t\tconsole.log(e);\r\n\t\t\t\t\tglobal.emitter.emit(\"hide-full-loading\");\r\n\t\t\t\t\tvar exceptions = helper.showException(e);\r\n\t\t\t\t}\r\n\t\t\t},\r\n\t\t\tshowModal: function(elementID){\r\n\t\t\t\t$(elementID).modal('show');\r\n\t\t\t},\r\n\t\t\tcloseModal: function(elementID){\r\n\t\t\t\t$(elementID).modal('hide');\r\n\t\t\t},\r\n\t\t\tvalidate() {\r\n\t\t\t\tthis.mashro.validate();\r\n\t\t\t},\r\n\t\t\tremove_image(image) {\r\n\t\t\t\tvar image_index = this.mashro.images.indexOf(image);\r\n\t\t\t\tif (image_index >= 0) this.mashro.images.splice(image_index, 1);\r\n\t\t\t\tif (this.mashro.images.length <= this.mashro.main_image_index)\r\n\t\t\t\t\tthis.mashro.main_image_index = this.mashro.images.length - 1;\r\n\t\t\t\tif (this.mashro.main_image_index < 0)\r\n\t\t\t\t\tthis.mashro.main_image_index = 0;\r\n\t\t\t\telse this.validate();\r\n\t\t\t},\r\n\t\t\tpickFile() {\r\n\t\t\t\tlet input = null;\r\n\t\t\t\tlet files = null;\r\n\t\t\t\t\r\n\t\t\t\tinput = this.$refs.file_input_parent;\r\n\t\t\t\tfiles = input.files;\r\n\r\n\t\t\t\tif (files && files[0]) {\r\n\t\t\t\t\tfor (let index = 0; index < files.length; index++) {\r\n\t\t\t\t\t\tconst single_file = files[index];\r\n\t\t\t\t\t\tlet reader = new FileReader();\r\n\t\t\t\t\t\treader.onload = (event) => {\r\n\t\t\t\t\t\t\tvar image = new Image();\r\n\t\t\t\t\t\t\timage.onload = ()=>{\r\n\t\t\t\t\t\t\t\tvar canvas=document.createElement(\"canvas\");\r\n\t\t\t\t\t\t\t\tvar context=canvas.getContext(\"2d\");\r\n\t\t\t\t\t\t\t\tconst size = 1024; // set your width\r\n\t\t\t\t\t\t\t\tvar scaleFactor = size / image.width;\r\n\t\t\t\t\t\t\t\tcanvas.width = image.width;\r\n\t\t\t\t\t\t\t\tcanvas.height = image.height;\r\n\t\t\t\t\t\t\t\tif(image.width > image.height && image.width > size){\r\n\t\t\t\t\t\t\t\t\tscaleFactor = size / image.width;\r\n\t\t\t\t\t\t\t\t\tcanvas.width = size;\r\n\t\t\t\t\t\t\t\t\tcanvas.height = image.height * scaleFactor;\r\n\t\t\t\t\t\t\t\t}else if(image.width < image.height && image.height > size){\r\n\t\t\t\t\t\t\t\t\tscaleFactor = size / image.height;\r\n\t\t\t\t\t\t\t\t\tcanvas.width = image.width * scaleFactor;\r\n\t\t\t\t\t\t\t\t\tcanvas.height = size;\r\n\t\t\t\t\t\t\t\t}\r\n\t\t\t\t\t\t\t\tcontext.drawImage(image, 0, 0, canvas.width, canvas.height);\r\n\t\t\t\t\t\t\t\tthis.mashro.images.push(\r\n\t\t\t\t\t\t\t\t\tnew global.image_file({\r\n\t\t\t\t\t\t\t\t\tdata: canvas.toDataURL(\"image/jpeg\"),\r\n\t\t\t\t\t\t\t\t\tfile: single_file.name,\r\n\t\t\t\t\t\t\t\t\t})\r\n\t\t\t\t\t\t\t\t);\r\n\t\t\t\t\t\t\t}\r\n\t\t\t\t\t\t\timage.src=event.target.result;\r\n\t\t\t\t\t\t\tconsole.log(\"added image\");\r\n\t\t\t\t\t\t\tconsole.log(this.mashro.images);\r\n\t\t\t\t\t\t\tthis.validate();\r\n\t\t\t\t\t\t};\r\n\t\t\t\t\t\treader.readAsDataURL(single_file);\r\n\t\t\t\t\t}\r\n\t\t\t\t\tthis.$forceUpdate();\r\n\t\t\t\t}\r\n\t\t\t},\r\n\t\t\tcheck_error(field, is_guarantee_type = false) {\r\n\t\t\t\treturn this.mashro.errors.includes(field) ? \"error\" : \"\";\r\n\t\t\t},\r\n\t\t\tsetup_map(initial_lat_lng = [24.69999996, 46.73333003]) {\r\n\t\t\t\tvar initial_lat = initial_lat_lng[0]; \r\n\t\t\t\tvar initial_lng = initial_lat_lng[1];\r\n\t\t\t\tif(this.edit_mashro){\r\n\t\t\t\t\tvar initial_lat = this.mashro.lat; \r\n                \tvar initial_lng = this.mashro.lng;\r\n\t\t\t\t}\t\r\n\t\t\t\tlet corner1 = L.latLng(31.896210012370656, 33.96066018865814);\r\n\t\t\t\tlet corner2 = L.latLng(17.613607036429755, 55.8301100044458);\r\n\t\t\t\tvar google_street_layer = L.tileLayer(\r\n\t\t\t\t\"https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}\",\r\n\t\t\t\t{\r\n\t\t\t\t\tmaxZoom: 18,\r\n\t\t\t\t\tminZoom: 6,\r\n\t\t\t\t\tsubdomains: [\"mt0\", \"mt1\", \"mt2\", \"mt3\"],\r\n\t\t\t\t\tattribution: '&copy; <a href=\"https://maalek.net\">Maalek.Net</a>',\r\n\t\t\t\t}\r\n\t\t\t\t);\r\n\t\t\t\tvar google_satellite_layer = L.tileLayer(\r\n\t\t\t\t\"https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}\",\r\n\t\t\t\t{\r\n\t\t\t\t\tmaxZoom: 18,\r\n\t\t\t\t\tminZoom: 6,\r\n\t\t\t\t\tsubdomains: [\"mt0\", \"mt1\", \"mt2\", \"mt3\"],\r\n\t\t\t\t\tattribution: '&copy; <a href=\"https://maalek.net\">Maalek.Net</a>',\r\n\t\t\t\t}\r\n\t\t\t\t);\r\n\t\t\t\tvar open_street = L.tileLayer(\r\n\t\t\t\t\"https://tile.openstreetmap.org/{z}/{x}/{y}.png\",\r\n\t\t\t\t{\r\n\t\t\t\t\tmaxZoom: 18,\r\n\t\t\t\t\tminZoom: 6,\r\n\t\t\t\t\tattribution: '&copy; <a href=\"https://maalek.net\">Maalek.Net</a>',\r\n\t\t\t\t}\r\n\t\t\t\t);\r\n\t\t\t\tthis.mapsLayerGroup = new L.LayerGroup();\r\n\t\t\t\tthis.markerLayerGroup = new L.LayerGroup();\r\n\t\t\t\tthis.map = L.map(\"map\", {\r\n\t\t\t\t\tcenter: [initial_lat, initial_lng],\r\n\t\t\t\t\tzoom: this.edit_mashro?16:10,\r\n                    maxZoom: 18,\r\n                    minZoom: 10,\r\n\t\t\t\t\tdragging: true,\r\n\t\t\t\t\tmaxBounds: L.latLngBounds(corner1, corner2),\r\n\t\t\t\t\tlayers: [\r\n\t\t\t\t\t\tthis.mapsLayerGroup,\r\n\t\t\t\t\t\tthis.markerLayerGroup,\r\n\t\t\t\t\t],\r\n\t\t\t\t}); //.setView([26.354351281510784, 43.95774780060444], 11);\r\n\t\t\t\tthis.map.scrollWheelZoom.disable();\r\n\t\t\t\tthis.mapsLayerGroup.addLayer(open_street);\r\n\r\n\t\t\t\t// this.drawnItems = new L.FeatureGroup();\r\n\t\t\t\tthis.map.addLayer(this.drawnItems);\r\n\t\t\t\t\r\n\t\t\t\tL.drawLocal.draw.handlers.polygon.tooltip.start = helper.t('Click anywhere to start boundary');\r\n\t\t\t\tL.drawLocal.draw.handlers.polygon.tooltip.cont = helper.t('Click and continue drawing');\r\n\t\t\t\tL.drawLocal.draw.handlers.polygon.tooltip.end = helper.t('Click the first point to close the boundary');\r\n\t\t\t\tL.drawLocal.draw.toolbar.buttons.polygon = helper.t('Draw boundaries');\r\n\t\t\t\tL.drawLocal.draw.toolbar.actions = {title: helper.t('Cancel current boundary'), text: helper.t('Cancel')};\r\n\t\t\t\tL.drawLocal.draw.toolbar.finish = {title: helper.t('Finish boundary'), text: helper.t('Finish')};\r\n\t\t\t\tL.drawLocal.draw.toolbar.undo = {title: helper.t('Delete last point'), text: helper.t('Delete')};\r\n\t\t\t\tL.drawLocal.edit.handlers.remove.tooltip.text = helper.t('Click a mashro boundery to remove');\r\n\t\t\t\tL.drawLocal.edit.toolbar.buttons.edit = helper.t('Edit boundaries');\r\n\t\t\t\tL.drawLocal.edit.toolbar.buttons.editDisabled = helper.t('No boundary found on Map');\r\n\t\t\t\tL.drawLocal.edit.toolbar.buttons.removeDisabled = helper.t('No mashro added on Map');\r\n\t\t\t\tL.drawLocal.edit.toolbar.buttons.remove = helper.t('Remove boundaries');\r\n\t\t\t\tL.drawLocal.edit.toolbar.remove = helper.t('Remove boundaries');\r\n\t\t\t\tL.drawLocal.edit.toolbar.actions.save = {title: helper.t('Save'), text: helper.t('Save')};\r\n\t\t\t\tL.drawLocal.edit.toolbar.actions.cancel = {title: helper.t('Cancel'), text: helper.t('Cancel')};\r\n\t\t\t\tL.drawLocal.edit.toolbar.actions.clearAll = {title: helper.t('Clear'), text: helper.t('Clear All')};\r\n\t\t\t\t\r\n\r\n\t\t\t\tconst drawControl = new L.Control.Draw({\r\n\t\t\t\t\tdraw: {\r\n\t\t\t\t\t\tpolygon: {\r\n\t\t\t\t\t\t\tallowIntersection: false,\r\n\t\t\t\t\t\t\tshowArea: true,\r\n\t\t\t\t\t\t\tshapeOptions: {\r\n\t\t\t\t\t\t\t\tcolor: '#ff89ff'\r\n\t\t\t\t\t\t\t}\r\n\t\t\t\t\t\t},\r\n\t\t\t\t\t\tpolyline: false,\r\n\t\t\t\t\t\trectangle: false,\r\n\t\t\t\t\t\tcircle: false,\r\n\t\t\t\t\t\tcirclemarker: false,\r\n\t\t\t\t\t\tmarker: false\r\n\t\t\t\t\t},\r\n\t\t\t\t\tedit: {\r\n\t\t\t\t\t\tfeatureGroup: this.drawnItems,\r\n\t\t\t\t\t\tremove: true\r\n\t\t\t\t\t}\r\n\t\t\t\t});\r\n\r\n\t\t\t\tthis.map.addControl(drawControl);\r\n\r\n\t\t\t\tthis.map.on(L.Draw.Event.CREATED, (event) => {\r\n\t\t\t\t\tconst layer = event.layer;\r\n\t\t\t\t\tthis.drawnItems.addLayer(layer);\r\n\t\t\t\t\t// const geojson = this.drawnItems.toGeoJSON();\r\n\t\t\t\t\t// this.mashro.location = geojson;\r\n\t\t\t\t});\r\n\r\n\t\t\t\tif(this.edit_mashro){\r\n\t\t\t\t\tvar geo_json = JSON.parse(this.mashro.location);\r\n\t\t\t\t\tconst geoJsonLayer = L.geoJSON(geo_json);\r\n\t\t\t\t\tgeoJsonLayer.eachLayer((layer) => {\r\n\t\t\t\t\t\tthis.drawnItems.addLayer(layer);\r\n\t\t\t\t\t});\r\n\t\t\t\t}\t\t\t\t\r\n\t\t\t},\r\n            set_guarantee_type(guarantee_type,if_zero = false){\r\n                if(if_zero && this.mashro.guarantees[guarantee_type]!=0){\r\n                    return\r\n                }\r\n                this.mashro.guarantees[guarantee_type] = this.mashro.guarantees[guarantee_type]==0?5:0;\r\n            },\r\n            set_property_type(property_type,if_zero = false){\r\n                this.mashro.property_types[property_type] = !this.mashro.property_types[property_type];\r\n            },\r\n            member_changed(){\r\n\t\t\t\tthis.mashro.contact_no = '0' + frappe.session_user.substring(4);\r\n\t\t\t\tthis.mashro.contact_email = this.owner_email;\r\n\t\t\t\tif(this.mashro.to_member && this.mashro.to_member != \"\"){\r\n\t\t\t\t\tthis.mashro.contact_no = '0' + this.mashro.to_member.member.substring(4);\r\n\t\t\t\t\tthis.mashro.contact_email = this.mashro.to_member.email;\r\n\t\t\t\t}\r\n\t\t\t\tthis.validate();\r\n            },\r\n\t\t\thandleFileChange(event) {\r\n\t\t\t\tconst file = event.target.files[0]\r\n\t\t\t\tthis.mashro.manual_file = file ? file.name : ''\r\n\t\t\t},\r\n\t\t\tconfirm_change_manual: async function (){\r\n\t\t\t\tbootbox.confirm({\r\n\t\t\t\t\tmessage: `<div class=\"alert alert-danger\" role=\"alert\">\r\n\t\t\t\t\t\t\t<b>`+helper.t(\"Do you want to re-upload project brochure?\")+`</b><br>\r\n\t\t\t\t\t\t\t<small>`+helper.t(\"Caution: This will remove previous pdf file.\")+`</small>\r\n\t\t\t\t\t</div>`,\r\n\t\t\t\t\tbuttons: {\r\n\t\t\t\t\t\tconfirm: {\r\n\t\t\t\t\t\t\tlabel: helper.t(\"Yes\"),\r\n\t\t\t\t\t\t\tclassName: 'btn-success'\r\n\t\t\t\t\t\t},\r\n\t\t\t\t\t\tcancel: {\r\n\t\t\t\t\t\t\tlabel: helper.t(\"No\"),\r\n\t\t\t\t\t\t\tclassName: 'btn-danger'\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t},\r\n\t\t\t\t\tbackdrop: true,\r\n\t\t\t\t\tcallback: (results) => results?this.$refs.pdfFileInput.click():console.log(\"cancel\"),\r\n\t\t\t\t});\r\n\t\t\t},\r\n\t\t\tonPickFile () {\r\n\t\t\t\tif(this.edit_mashro && this.mashro.manual_doc){\r\n\t\t\t\t\tthis.confirm_change_manual();\r\n\t\t\t\t}else{\r\n\t\t\t\t\tthis.$refs.pdfFileInput.click()\r\n\t\t\t\t}\r\n\t\t\t},\r\n\t\t\tpdfPickFile () {\r\n                let input = null;\r\n                let files = null;\r\n                input = this.$refs.pdfFileInput;\r\n                files = input.files;\r\n                if (files && files[0]) {\r\n\t\t\t\t\tconst fileReader = new FileReader()\r\n\t\t\t\t\tfileReader.readAsDataURL(files[0])\r\n\t\t\t\t\tlet reader = new FileReader;\r\n\t\t\t\t\treader.onload = e => {\r\n\t\t\t\t\t\tthis.mashro.manual_file = new global.pdf_file({\r\n\t\t\t\t\t\t\tdata: e.target.result,\r\n\t\t\t\t\t\t\tfile: files[0].name,\r\n\t\t\t\t\t\t\ttype: files[0].type,\r\n\t\t\t\t\t\t});\r\n\t\t\t\t\t}\r\n\t\t\t\t\treader.readAsDataURL(files[0]);\r\n\t\t\t\t\tthis.$forceUpdate();\r\n                }\r\n            },\r\n\t\t\tset_communication (type) {\r\n\t\t\t\tif(type == 'phone'){\r\n\t\t\t\t\tif(this.mashro.phone && (this.mashro.email || this.mashro.whatsapp)){\r\n\t\t\t\t\t\tthis.mashro.phone = false;\r\n\t\t\t\t\t}else if(this.mashro.phone){\r\n\t\t\t\t\t\thelper.showException(\"Atleast one communication method is needed\");\r\n\t\t\t\t\t}else{\r\n\t\t\t\t\t\tthis.mashro.phone = true;\r\n\t\t\t\t\t}\r\n\t\t\t\t}else if(type == 'whatsapp'){\r\n\t\t\t\t\tif(this.mashro.whatsapp && (this.mashro.phone || this.mashro.email)){\r\n\t\t\t\t\t\tthis.mashro.whatsapp = false;\r\n\t\t\t\t\t}else if(this.mashro.whatsapp){\r\n\t\t\t\t\t\thelper.showException(\"Atleast one communication method is needed\");\r\n\t\t\t\t\t}else{\r\n\t\t\t\t\t\tthis.mashro.whatsapp = true;\r\n\t\t\t\t\t}\r\n\t\t\t\t}else if(type == 'email'){\r\n\t\t\t\t\tif(this.mashro.email && (this.mashro.phone || this.mashro.whatsapp)){\r\n\t\t\t\t\t\tthis.mashro.email = false;\r\n\t\t\t\t\t}else if(this.mashro.email){\r\n\t\t\t\t\t\thelper.showException(\"Atleast one communication method is needed\");\r\n\t\t\t\t\t}else{\r\n\t\t\t\t\t\tthis.mashro.email = true;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t},\r\n\t\tcomputed:{\r\n\t\t}\r\n\t}\r\n</script>\r\n\r\n<style>\r\n.image-input-container {\r\n  display: block;\r\n  position: relative;\r\n}\r\n.image-input-container .delete {\r\n  position: absolute;\r\n  top: 5%;\r\n  right: 10%;\r\n  text-shadow: 1px 1px 2px #000;\r\n}\r\n.image-input-container .main {\r\n  position: absolute;\r\n  top: 5%;\r\n  left: 10%;\r\n  text-shadow: 1px 1px 2px #000;\r\n}\r\n.image-input-container .input-file {\r\n  height: 0.1px;\r\n  width: 0.1px;\r\n  display: none;\r\n}\r\n.imagePreviewWrapper {\r\n  width: 100%;\r\n  padding-top: 100%;\r\n  display: block;\r\n  cursor: pointer;\r\n  margin: 0 auto 30px;\r\n  background-color: aliceblue;\r\n  background-repeat: no-repeat;\r\n  background-size: cover;\r\n  background-position: center;\r\n}\r\n.imageEmptyWrapper {\r\n  width: 100%;\r\n  padding-top: 100%;\r\n  display: block;\r\n  cursor: pointer;\r\n  margin: 0 auto 30px;\r\n  background-color: aliceblue;\r\n  background-image: url(\"/assets/maalek/images/circle-plus-solid.svg\");\r\n  background-repeat: no-repeat;\r\n  background-size: 20%;\r\n  background-position: center;\r\n}\r\n.images-container {\r\n  padding: 5px;\r\n}\r\n.images-container.error {\r\n  border: SOLID 1px red;\r\n  background-color: rgba(255, 0, 0, 0.1215686275) !important;\r\n}\r\n#app {\r\n\ttext-align: center;\r\n\tcolor: #2c3e50;\r\n\tmargin-top: 60px;\r\n}\r\n.single-pricing .default-btn{\r\n\tmargin-bottom: unset;\r\n}\r\n.features-content ul *{\r\n\tcursor: pointer;\r\n}\r\n.pricing-switch{\r\n\tmargin-bottom: 0;\r\n\tmargin-top: 10px;\r\n\ttext-align: start;\r\n}\r\n.pricing-switch .toggler{\r\n\tmargin-top: 10px;\r\n}\r\n.accordion-item .accordion-body ul li::before {\r\n\tdisplay: none;\r\n}\r\n.features-content *{\r\n\tuser-select: none;\r\n}\r\n\r\n.floor-table{\r\n\tborder-right: SOLID 2px #014116;\r\n}\r\n\r\n.floor-table h3{\r\n\tfont-size: 1.2rem;\r\n}\r\n\r\n.floor-table .actions *{\r\n\tcolor: #014116;\r\n}\r\n\r\n.floor-row:hover{\r\n\tbackground-color: aliceblue;\r\n}\r\n\r\n.show-on-hover, .show-on-hover-child{\r\n\tcursor: pointer;\r\n}\r\n\r\n.floor-row .show-on-hover{\r\n\tdisplay: none;\r\n}\r\n\r\n.floor-row:hover .show-on-hover{\r\n\tdisplay: block;\r\n}\r\n\r\n.tags{\r\n\tcursor: pointer;\r\n}\r\n\r\n.tags:hover{\r\n\tbackground-color: #014116;\r\n}\r\n\r\n.tags:hover *{\r\n\tcolor: #fff;\r\n}\r\n\r\n.tags span{\r\n\tborder: SOLID 2px;\r\n\tpadding: 5px;\r\n}\r\n.tags ul{\r\n\tpadding: 5px !important;\r\n}\r\n.tags ul li{\r\n\tpadding-left: 5px !important;\r\n\tdisplay: inline-block !important;\r\n}\r\n.modal-dialog{\r\n\t/* max-width: 70% !important; */\r\n}\r\n.add_property_widget{\r\n\tposition: relative;\r\n}\r\n.modal-content {\r\n  overflow: auto !important;\r\n}\r\n.features-content ul {\r\n\tpadding-left: 0;\r\n\tmargin-bottom: 0;\r\n\tlist-style-type: none;\r\n\tmargin-bottom: 10px;\r\n}\r\n.form-check-input:checked {\r\n\tbackground-color: green;\r\n\tborder-color: darkgreen;\r\n}\r\n.form-check-input:focus {\r\n\t--bs-form-check-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23198754'/%3e%3c/svg%3e\");\r\n  \tbox-shadow: 0 0 0 0.15rem lightgreen;\r\n}\r\n.property_type{\r\n\tborder: 1px solid #e5e7eb;\r\n\tborder-radius: 12px;\r\n\tpadding: 18px;\r\n\ttext-align: center;\r\n\ttransition: 0.2s;\r\n\tcursor: pointer;\r\n\theight: 100%;\r\n}\r\n.property_type:hover {\r\n\tborder-color: #198754;\r\n\tbackground: #f8fffb;\r\n\tcolor: green;\r\n}\r\n.property_type.selected{\r\n\tbackground-color: green;\r\n\tcolor: white;\r\n}\r\n.property_type.selected:hover {\r\n\tborder-color: #198754;\r\n}\r\n.property_type img {\r\n\twidth: 40px;\r\n}\r\n.facility_type{\r\n\tborder: 1px solid #e5e7eb;\r\n\tborder-radius: 12px;\r\n\tpadding: 18px;\r\n\ttext-align: center;\r\n\ttransition: 0.2s;\r\n\tcursor: pointer;\r\n\theight: 100%;\r\n}\r\n.facility_type i{\r\n\tfont-size: 1.5rem;\r\n}\r\n.facility_type.selected{\r\n\tbackground-color: green;\r\n\tcolor: white;\r\n}\r\n.facility_type.selected i{\r\n\tcolor: white;\r\n}\r\n.facility_type:hover{\r\n\tborder-color: #198754;\r\n\tbackground: #f8fffb;\r\n\tcolor: green;\r\n}\r\n\r\n.facility_type:hover i {\r\n\tborder-color: #198754;\r\n\tbackground: #f8fffb;\r\n\tcolor: green;\r\n}\r\n</style>\r\n"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "../maalek/maalek/public/vue/widgets/add-mashro-widget.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__